<template>
    <v-container class="bodyPage page">
        
        <div id="topMenu" class="topMenu" v-once>
            <v-icon 
                class="downIcon"
                large 
                color="grey"
                @click="expandMenu"
            >
                mdi-chevron-down
            </v-icon>
            <v-card id="topMenuCard" class="elevation-1 topMenuCard" v-once> 
                <v-list-item two-line>
                    <v-list-item-content v-resize="onResize">
                        <v-list-item-title class="text-h7 headerCallInfo" style="margin-bottom:10px; font-weight:bolder; display:flex; height: 1.8em;">
                            <!-- <span>{{labels.titlePage}}</span> -->
                            <v-spacer></v-spacer>
                            <div class="actions">
                                <v-btn
                                    x-small
                                    class="btn1"
                                    dark
                                    @click="goBack()"
                                >
                                    <v-icon x-small>
                                        mdi-arrow-left
                                    </v-icon>
                                    <span style="margin-left: 4px;">{{ 'Voltar' | translate('Atendimento') }}</span>
                                </v-btn>
                                <v-btn 
                                    style="margin-left: 8px;"
                                    x-small 
                                    class="btn1"
                                    dark
                                    @click="save"
                                    :disabled="disableSave()"
                                > 
                                    <v-icon x-small>
                                        mdi-check
                                    </v-icon>
                                    <span style="margin-left: 4px;">{{'Salvar' | translate('Atendimento')}}</span>
                                </v-btn>
                                <v-btn 
                                    v-if="!user.CLIENTE_ID"
                                    style="margin-left: 8px;"
                                    x-small 
                                    color="black"
                                    class="btn1 white--text"
                                    @click="openConfirmationNewOrder()"
                                >
                                    <v-icon x-small>
                                        mdi-file-document-multiple-outline
                                    </v-icon>
                                    <span style="margin-left: 4px;">{{'Pedido' | translate('Atendimento')}}</span>
                                </v-btn>
                                <v-btn 
                                    x-small 
                                    style="margin-left: 8px;"
                                    color="black"
                                    class="btn1 white--text"
                                    @click="print"
                                    :disabled="disableSave()"
                                > 
                                    <v-icon x-small>
                                        mdi-printer
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-title>
                        <v-list-item-title class="text-h7 bolder" style="margin-bottom:10px; font-weight:bolder;" v-once>
                            {{labels.titlePage}}
                        </v-list-item-title>
                        <v-list-item-subtitle style="display:flex;">
                            <v-chip
                                v-if="call.ID"
                                x-small 
                                text 
                                rounded 
                                class="fontSize bolder" 
                                style="background: #e0e0e0; margin-right: .5em;"
                            >
                                {{ call.ID }}
                            </v-chip>
                            <!-- <v-btn v-if="call.ID" x-small text rounded outlined class="bolder" style="background: #e0e0e0; margin-right:1px;">{{call.ID}}</v-btn> -->
                            <v-tooltip v-for="call in  this.relatedCalls" :key="call.ID" right class="fontSize">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        rounded
                                        class="fontSize red-x-icon"
                                        x-small
                                        outlined
                                        style="margin-right: .5em;"
                                        @click="gotoCall(call.ID)"
                                        @click:close="call.REMOVE = true"
                                        close
                                    >
                                        {{ call.ID }}
                                    </v-chip>
                                </template>
                                <span class="text-truncate">
                                    {{call.ASSUNTO}}
                                </span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="openCallsLinkModal()"
                                        :disabled="!!user.CLIENTE_ID || isOperator"
                                    >
                                        <v-icon>
                                            mdi-plus-circle
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{'Vincular Atendimentos' | translate('Atendimento')}}</span>
                            </v-tooltip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <!-- <v-list-item>
                    <v-list-item-content>
                        <v-list-item-subtitle style="display:flex;">
                            <v-btn v-if="call.ID" x-small text rounded outlined class="bolder" style="background: #e0e0e0; margin-right:1px;">{{call.ID}}</v-btn>
                            <v-tooltip v-for="(order, i) in  call.relatedOrders" :key="i" right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text 
                                        rounded 
                                        outlined  
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="gotoOrder(order.ID)" style="margin-right:1px;"
                                    >
                                        {{order.ID}}
                                    </v-btn>
                                </template>
                                <span class="text-truncate;">
                                    {{order.ASSUNTO}}
                                </span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="callsLinkDialog = true"
                                    >
                                        <v-icon>
                                            mdi-plus-circle
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{'Vincular Atendimento' | translate('Atendimento')}}</span>
                            </v-tooltip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item> -->
                <v-divider></v-divider>
                <div class="leftMenuCardBody">
                    <v-row v-if="!callId && !user.CLIENTE_ID">
                        <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                            <v-text-field v-model="call.ID">
                                <template #label>
                                    <span>{{labels.ra_number}}</span> 
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="!user.CLIENTE_ID">
                        <v-col style="padding-bottom:0px;" class="bolder fontSize">
                            <v-text-field v-model="call.PEDIDO" chips>
                                <template #label>
                                    <span>{{labels.pedido}}</span> 
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="padding-bottom:0px;" class="bolder fontSize">
                            <v-text-field v-model="call.ASSUNTO" :disabled="this.isOperator">
                                    <template #label>
                                        <span>{{labels.assunto}}</span> 
                                        <span class="red--text"><strong>*</strong></span>
                                    </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                            <template>
                                <v-autocomplete
                                    dense
                                    height="30px"
                                    clearable
                                    v-model="call.product_module"
                                    :items="product_modules"
                                    item-text="CALL"
                                    item-value="ID"
                                    :disabled="this.isOperator"
                                    return-object
                                    :menu-props="{closeOnContentClick:true}"
                                    chips
                                >
                                    <template #label>
                                        <span>{{labels.product_module}}</span> 
                                        <span class="red--text"><strong>*</strong></span>
                                    </template>
                                </v-autocomplete>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                            <!-- CLIENTE MOBILE -->
                            <template>
                                <v-combobox
                                    dense
                                    height="30px"
                                    clearable
                                    v-model="call.client"
                                    :items="clients"
                                    :search-input.sync="fastSearchClients"
                                    @focus="changeSearchProperty('clients')"
                                    @change="clearRequesters()"
                                    item-text="NOME"
                                    item-value="ID"
                                    return-object
                                    hide-selected
                                    chips
                                    :disabled="!!user.CLIENTE_ID || this.isOperator"
                                    :menu-props="{closeOnContentClick:true}"
                                >
                                    <template #label>
                                        <span>{{labels.cliente}}</span> 
                                        <span class="red--text"><strong>*</strong></span>
                                    </template>
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2">
                                                {{ item.NOME }}
                                            </span>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2">
                                            {{ item.NOME }}
                                        </span>
                                    </template>
                                    <template v-if="fastSearchClients" v-slot:no-data>
                                        <span> </span>
                                    </template>
                                    <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                        <v-row>
                                            <v-col class="noPaddingCol">
                                                <v-btn 
                                                    plain 
                                                    style="width: inherit;" 
                                                    @click="addClient()"
                                                >
                                                    <v-icon color="#1976d2">
                                                        mdi-account-plus-outline
                                                    </v-icon>
                                                    <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Cliente' | translate('Atendimento')}}</span>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-combobox>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.isCustomer || this.isCreating">
                        <v-col class="noPaddingCol bolder fontSize">
                            <!-- SOLICITANTE MOBILE -->
                            <template>
                                <v-combobox
                                    id="requestersInput"
                                    dense
                                    clearable
                                    v-model="call.callRequesters"
                                    :items="requesters"
                                    :search-input.sync="fastSearchRequesters"
                                    @focus="changeSearchProperty('requesters')"
                                    item-text="NOME"
                                    return-object
                                    hide-selected
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                >
                                    <template #label>
                                        <span>{{labels.solicitantes}}</span> 
                                        <span class="red--text"><strong>*</strong></span>
                                    </template>
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2">
                                                {{ item.NOME }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2">
                                            {{ item.NOME }}
                                        </span>
                                    </template>
                                    <template v-if="fastSearchRequesters" v-slot:no-data>
                                        <span> </span>
                                    </template>
                                    <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                        <v-row>
                                            <v-col class="noPaddingCol">
                                                <v-btn 
                                                    plain 
                                                    style="width: inherit;" 
                                                    @click="addUser('requester')"
                                                >
                                                    <v-icon color="#1976d2">
                                                        mdi-account-plus-outline
                                                    </v-icon>
                                                    <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Solicitante' | translate('Atendimento')}}</span>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-combobox>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.isCustomer || this.isCreating">
                        <v-col class="noPaddingCol bolder fontSize">
                            <!-- RESPONSÁVEL MOBILE -->
                            <template>
                                <v-combobox
                                    dense
                                    :clearable="!call.callResponsible"
                                    v-model="call.callResponsibles"
                                    :items="responsibles"
                                    :label="labels.responsaveis"
                                    :search-input.sync="fastSearchResponsibles"
                                    @focus="changeSearchProperty('responsibles')"
                                    @blur="setCallResponsibles()"
                                    item-text="NOME"
                                    return-object
                                    hide-selected
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                    :disabled="!!user.CLIENTE_ID"
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2">
                                                {{ item.NOME }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                                :disabled="item == call.responsible"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2">
                                            {{ item.NOME }}
                                        </span>
                                    </template>
                                    <template v-if="fastSearchResponsibles" v-slot:no-data>
                                        <span> </span>
                                    </template>
                                    <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                        <v-row>
                                            <v-col class="noPaddingCol">
                                                <v-btn 
                                                    plain 
                                                    style="width: inherit;" 
                                                    @click="addUser('responsible')"
                                                >
                                                    <v-icon color="#1976d2">
                                                        mdi-account-plus-outline
                                                    </v-icon>
                                                    <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Responsável' | translate('Atendimento')}}</span>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-combobox>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.isOperator">
                        <v-col class="noPaddingCol bolder fontSize">
                            <!-- RESPONSÁVEL MOBILE -->
                            <template>
                                <v-combobox
                                    dense
                                    v-model="call.callInternalResponsibles"
                                    :items="responsibles"
                                    :label="labels.responsaveis_internos"
                                    :search-input.sync="fastSearchResponsibles"
                                    @focus="changeSearchProperty('responsibles')"
                                    @blur="setCallResponsibles()"
                                    item-text="NOME"
                                    return-object
                                    hide-selected
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                    :disabled="!!user.CLIENTE_ID"
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2">
                                                {{ item.NOME }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                                :disabled="item == call.responsible"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2">
                                            {{ item.NOME }}
                                        </span>
                                    </template>
                                    <template v-if="fastSearchResponsibles" v-slot:no-data>
                                        <span> </span>
                                    </template>
                                    <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                        <v-row>
                                            <v-col class="noPaddingCol">
                                                <v-btn 
                                                    plain 
                                                    style="width: inherit;" 
                                                    @click="addUser('responsible')"
                                                >
                                                    <v-icon color="#1976d2">
                                                        mdi-account-plus-outline
                                                    </v-icon>
                                                    <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Responsável' | translate('Atendimento')}}</span>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-combobox>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row class="default-margin-bottom; flex-wrap:no-wrap;" v-if="this.isCustomer || this.isCreating">
                        <v-col class="noPaddingCol bolder fontSize">
                            <v-autocomplete
                                v-model="call.callResponsible"
                                :items="acao_com_list"
                                menu-props="auto"
                                :label="labels.acao_com"
                                item-value="USUARIO_ID"
                                item-text="NOME"
                                return-object
                                :no-data-text="labels.selectResponsibleTextNoData"
                            >
                                <template v-slot:selection="{ item }">
                                    <span>
                                        <v-avatar
                                            size="22"
                                            style="margin-right: 1em;"
                                        >
                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                    </v-avatar>
                                    {{ item.NOME }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col class="noPaddingCol bolder fontSize" cols="2">
                            <v-select
                                v-model="call.situation"
                                :items="situations"
                                menu-props="auto"
                                :label="labels.situacao"
                                item-value="ID"
                                item-text="NOME"
                                hide-details
                                return-object
                                :disabled="!!user.CLIENTE_ID"
                            >
                                <template v-slot:selection="{ item }">
                                    <v-avatar
                                        :color="item.COR"
                                        size="18"
                                        style="margin-right: 1em;"
                                    ></v-avatar>
                                    <span class="d-inline-block text-truncate">{{ item.NOME }}</span>
                                </template>
                                <template v-slot:[`item`]="{ item }">
                                    <v-avatar
                                        :color="item.COR"
                                        size="18"
                                        style="margin-right: 1em;"
                                    ></v-avatar>
                                    <span>{{ item.NOME }}</span>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.isCustomer || this.isCreating">
                        <v-col class="bolder fontSize">
                            <span>{{'Data início' | translate('Atendimento')}}</span>
                            <span class="red--text"><strong>*</strong></span>
                            <date-picker v-model="call.DATA_INICIO" :placeholder="labels.data_inicio" format="DD/MM/YYYY" valueType="format" style="width: 100%;" :disabled="!!user.CLIENTE_ID"/>
                        </v-col>
                        <v-col class="bolder fontSize">
                            <span>{{'Data limite' | translate('Atendimento')}}</span>
                            <date-picker v-model="call.DATA_LIMITE" :placeholder="labels.data_final" format="DD/MM/YYYY" valueType="format" style="width: 100%;"/>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col class="noPaddingCol bolder fontSize">
                            <v-text-field
                                disabled
                                :label="labels.titulo_negocio"
                            ></v-text-field>
                        </v-col>
                    </v-row> -->
                    <!-- <v-row>
                        <v-col class="noPaddingCol bolder fontSize">
                            <template>
                                <v-combobox
                                    disabled
                                    dense
                                    height="30px"
                                    clearable
                                    v-model="call.products"
                                    :items="products"
                                    :label="labels.busca_produtos"
                                    :search-input.sync="fastSearchProducts"
                                    @focus="changeSearchProperty('products')"
                                    item-text="NOME"
                                    return-object
                                    hide-selected
                                    chips
                                    multiple
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <span class="pr-2">
                                                {{ item.NOME }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                </v-combobox>
                            </template>
                        </v-col>
                    </v-row> -->
                    <!-- <v-row>
                        <v-col>
                            <template>
                                <v-data-table
                                    max-height="15em"
                                    :headers="productTableHeaders"
                                    :items="call.products"
                                    hide-default-header
                                    hide-default-footer
                                    :no-data-text="labels.tableProductTextNoData"
                                    class="elevation-1"
                                ></v-data-table>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="textRight">
                            <span class="bolder">{{labels.valor_mensal}}:</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="textRight">
                            <span class="bolder">{{labels.valor_negocio}}:</span>
                        </v-col>
                    </v-row> -->
                </div>
                <!-- <v-card-actions class="cardActions">
                    <v-spacer></v-spacer>
                    <v-btn text outlined color="primary" class="bolder"> {{'Gerar Proposta' | translate('Atendimento')}} </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text outlined color="primary" class="bolder"> {{'Gerar Contrato' | translate('Atendimento')}} </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text outlined color="primary" class="bolder"> {{'Gerar Pedido' | translate('Atendimento')}} </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions> -->
            </v-card>
        </div>
        <body style="height:100%;">
            <v-row style="height:100%; margin:0;" class="pageWrap">
                <div class="leftMenu formCard" :class="drawer? 'drawer':null" >
                    <v-card width="100%" height="100%" class="elevation-4" style="overflow: hidden; padding-bottom:50px;">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="text-h7 headerCallInfo" style="font-weight:bolder; display:flex; height: 1.8em;">
                                    <!-- {{labels.titlePage}}
                                    <v-spacer></v-spacer> -->
                                    <div class="actions" >
                                        <v-btn
                                            x-small
                                            class="btn1"
                                            dark
                                            @click="goBack()"
                                        >
                                            <v-icon x-small>
                                                mdi-arrow-left
                                            </v-icon>
                                            <span style="margin-left: 4px;">{{ 'Voltar' | translate('Atendimento') }}</span>
                                        </v-btn>
                                        <v-btn 
                                            style="margin-left: 8px;"
                                            x-small 
                                            color="black"
                                            class="btn1 white--text"
                                            @click="save"
                                            :disabled="loading || disableSave()"
                                        > 
                                            <v-icon x-small>
                                                mdi-check
                                            </v-icon>
                                            <span style="margin-left: 4px;">{{'Salvar' | translate('Atendimento')}}</span>
                                        </v-btn>
                                        <v-btn 
                                            v-if="!user.CLIENTE_ID"
                                            style="margin-left: 8px;"
                                            x-small 
                                            color="black"
                                            class="btn1 white--text"
                                            @click="openConfirmationNewOrder()"
                                            :disabled="loading || !this.$route.query.id || !!this.defaultCall.PEDIDO"
                                        > 
                                            <v-icon x-small>
                                                mdi-file-document-multiple-outline
                                            </v-icon>
                                            <span style="margin-left: 4px;">{{'Pedido' | translate('Atendimento')}}</span>
                                        </v-btn>
                                        <v-btn 
                                            x-small 
                                            style="margin-left: 8px;"
                                            color="black"
                                            class="btn1 white--text"
                                            @click="print"
                                            :disabled="loading || disableSave()"
                                        > 
                                            <v-icon x-small>
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    x-small 
                                                    style="margin-left: 8px;"
                                                    color="black"
                                                    class="btn1 white--text"
                                                    @click="openSaveDialog()"
                                                    :disabled="loading || disableTechnicalDetailButton"
                                                > 
                                                    <v-icon x-small>
                                                        mdi-wrench-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{labels.technicalDetail}}</span>
                                        </v-tooltip>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-subtitle style="display:flex;">
                                    <v-chip
                                        v-if="call.ID"
                                        x-small 
                                        text 
                                        rounded 
                                        class="fontSize bolder" 
                                        :class="{ 'cursor-auto': isCustomerUser }"
                                        style="background: #e0e0e0; margin-right: .5em;"
                                        @click="goToCallType()"
                                    >
                                        {{ call.ID }}
                                    </v-chip>
                                    <!-- <v-btn v-if="call.ID" x-small text rounded outlined class="bolder" style="background: #e0e0e0; margin-right:1px;">{{call.ID}}</v-btn> -->
                                    <v-tooltip v-for="call in  this.relatedCalls" :key="call.ID" right class="fontSize">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip
                                                v-bind="attrs"
                                                v-on="on"
                                                rounded
                                                class="fontSize red-x-icon"
                                                x-small
                                                outlined
                                                style="margin-right: .5em;"
                                                @click="gotoCall(call.ID)"
                                                @click:close="call.REMOVE = true"
                                                close
                                            >
                                                {{ call.ID }}
                                            </v-chip>
                                        </template>
                                        <span class="text-truncate">
                                            {{call.ASSUNTO}}
                                        </span>
                                    </v-tooltip>
                                    <v-spacer></v-spacer>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                x-small 
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="openCallsLinkModal()"
                                                :disabled="!!user.CLIENTE_ID || isOperator"
                                            >
                                                <v-icon>
                                                    mdi-plus-circle
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{'Vincular Atendimentos' | translate('Atendimento')}}</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>
                        <!-- NÃO DELETAR, SERÁ USADO QUANDO PUDER ADICIONAR MAIS DE UM PEDIDO A UM ATENDIMENTO -->
                        <!-- <v-list-item two-line style="display: block; padding-top: 4px">
                            <v-list-item-title class="text-h7 headerCallInfo" style="margin-bottom:10px; font-weight:bolder; display:flex; height: 1em;">{{'Pedidos vinculados' | translate('Atendimento')}}</v-list-item-title>
                            <v-list-item-content style="padding:0px;">
                                <v-list-item-subtitle style="display:flex;">
                                    <v-tooltip v-for="(order, i) in  call.relatedOrders" :key="i" right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                x-small 
                                                text 
                                                rounded 
                                                outlined  
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="gotoOrder(order.ID)" style="margin-right:1px;"
                                            >
                                                {{order.ID}}
                                            </v-btn>
                                        </template>
                                        <span class="text-truncate;">
                                            {{order.ASSUNTO}}
                                        </span>
                                    </v-tooltip>
                                    <v-spacer></v-spacer>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                x-small 
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="ordersLinkDialog = true"
                                                :disabled="!!user.CLIENTE_ID"
                                            >
                                                <v-icon>
                                                    mdi-plus-circle
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{'Vincular Pedidos' | translate('Atendimento')}}</span>
                                    </v-tooltip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/> -->
                        <v-progress-linear
                            v-if="this.loading"
                            indeterminate
                            color="blue darken-2"
                            ></v-progress-linear>
                        <div class="leftMenuCardBody">

                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title style="">{{labels.pedido}}</v-list-item-title>
                                    <v-list-item-subtitle style="display:flex;padding:5px 10px 5px 10px; margin-bottom:-8px;">
                                        <v-chip
                                            v-if="call.PEDIDO"
                                            x-small 
                                            text 
                                            class="fontSize bolder kndChip" 
                                            style="background: #e0e0e0; margin-right: .5em; padding:15px; border-radius:15px;"
                                            @click="goToOrder()"
                                        >
                                            {{ call.PEDIDO }}
                                            <v-btn icon  @click="unlinkOrder()" style="margin-right:-15px;">
                                                <v-icon color='red'>mdi-close-circle</v-icon>
                                            </v-btn>
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    x-small 
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="openOrderLinkDialog()"
                                                    :disabled="!!user.CLIENTE_ID || isOperator"
                                                >
                                                    <v-icon>
                                                        mdi-plus-circle
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{'Vincular Pedido' | translate('Atendimento')}}</span>
                                        </v-tooltip>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                             <!-- <v-row v-if="!callId && !user.CLIENTE_ID">
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <v-text-field v-model="call.ID">
                                        <template #label>
                                            <span>{{labels.ra_number}}</span> 
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row> -->
                            <v-row>
                                <v-col style="padding-bottom:0px;" class="bolder fontSize">
                                    <v-text-field v-model="call.ASSUNTO" chips :disabled="this.isOperator">
                                        <template #label>
                                            <span>{{labels.assunto}}</span> 
                                            <span class="red--text"><strong>*</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <template>
                                        <v-autocomplete
                                            dense
                                            height="30px"
                                            clearable
                                            :disabled="this.isOperator"
                                            v-model="call.product_module"
                                            :items="product_modules"
                                            item-text="DESCRICAO"                                       
                                            return-object
                                            :menu-props="{closeOnContentClick:true}"
                                            chips                                        
                                        >
                                            <template #label>
                                                <span>{{labels.product_module}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                             <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <span class="pr-2">
                                                        {{ item.DESCRICAO }}
                                                    </span>
                                                </v-chip>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <!-- CLIENTE -->
                                    <template>
                                        <v-autocomplete
                                            dense
                                            height="30px"
                                            clearable
                                            v-model="call.client"
                                            :items="clients"
                                            item-text="NOME"
                                            item-value="ID"
                                            return-object
                                            hide-selected
                                            chips
                                            :disabled="!!user.CLIENTE_ID || this.isOperator"
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template #label>
                                                <span>{{labels.cliente}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2">
                                                        {{ item.NOME }}
                                                    </span>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-if="fastSearchClients" v-slot:no-data>
                                                <span> </span>
                                            </template>
                                            <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                                <v-row>
                                                    <v-col class="noPaddingCol">
                                                        <v-btn 
                                                            plain 
                                                            style="width: inherit;" 
                                                            @click="addClient()"
                                                        >
                                                            <v-icon color="#1976d2">
                                                                mdi-account-plus-outline
                                                            </v-icon>
                                                            <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Cliente' | translate('Atendimento')}}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.isCustomer || this.isCreating">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <!-- SOLICITANTE -->
                                    <template>
                                        <v-autocomplete
                                            id="requestersInput"
                                            dense
                                            clearable
                                            v-model="call.callRequesters"
                                            :items="requesters"
                                            @blur="setAcaoComList()"
                                            item-text="NOME"
                                            return-object
                                            hide-selected
                                            chips
                                            multiple
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template #label>
                                                <span>{{labels.solicitantes}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                    >
                                                        <v-icon color="red">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-if="fastSearchRequesters" v-slot:no-data>
                                                <span> </span>
                                            </template>
                                            <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                                <v-row>
                                                    <v-col class="noPaddingCol">
                                                        <v-btn 
                                                            plain 
                                                            style="width: inherit;" 
                                                            @click="addUser('requester')"
                                                        >
                                                            <v-icon color="#1976d2">
                                                                mdi-account-plus-outline
                                                            </v-icon>
                                                            <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Solicitante' | translate('Atendimento')}}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.isCustomer || this.isCreating">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <template>
                                        <!-- RESPONSÁVEL -->
                                        <v-autocomplete
                                            dense
                                            :clearable="!call.callResponsible"
                                            v-model="call.callResponsibles"
                                            :items="responsibles"
                                            :label="labels.responsaveis"
                                            @blur="setAcaoComList()"
                                            item-text="NOME"
                                            return-object
                                            hide-selected
                                            chips
                                            multiple
                                            :disabled="!!user.CLIENTE_ID"
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                        :disabled="item == call.responsible"
                                                    >
                                                        <v-icon color="red">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-if="fastSearchResponsibles" v-slot:no-data>
                                                <span> </span>
                                            </template>
                                            <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                                <v-row>
                                                    <v-col class="noPaddingCol">
                                                        <v-btn 
                                                            plain 
                                                            style="width: inherit;" 
                                                            @click="addUser('responsible')"
                                                        >
                                                            <v-icon color="#1976d2">
                                                                mdi-account-plus-outline
                                                            </v-icon>
                                                            <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Responsável' | translate('Atendimento')}}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.isOperator">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <template>
                                        <!-- RESPONSÁVEL -->
                                        <v-autocomplete
                                            dense
                                            v-model="call.callInternalResponsibles"
                                            :items="responsibles"
                                            :label="labels.responsaveis_internos"
                                            @blur="setAcaoComList()"
                                            item-text="NOME"
                                            return-object
                                            hide-selected
                                            chips
                                            multiple
                                            :disabled="!!user.CLIENTE_ID"
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                        :disabled="item == call.responsible"
                                                    >
                                                        <v-icon color="red">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-if="fastSearchResponsibles" v-slot:no-data>
                                                <span> </span>
                                            </template>
                                            <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                                <v-row>
                                                    <v-col class="noPaddingCol">
                                                        <v-btn 
                                                            plain 
                                                            style="width: inherit;" 
                                                            @click="addUser('responsible')"
                                                        >
                                                            <v-icon color="#1976d2">
                                                                mdi-account-plus-outline
                                                            </v-icon>
                                                            <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Responsável' | translate('Atendimento')}}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row class="default-margin-bottom" v-if="getUserType() === 'operator'">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-select
                                        v-model="call.section"
                                        :items="sections"
                                        menu-props="auto"
                                        :label="labels.responsibleSection"
                                        item-value="ID"
                                        item-text="DESCRICAO"
                                        hide-details
                                        return-object
                                        :disabled="!!user.CLIENTE_ID"
                                        clearable
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span class="d-inline-block text-truncate">
                                                {{ item.DESCRICAO | translate('Atendimento') }}
                                            </span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <span class="d-block text-truncate">
                                                {{ item.DESCRICAO | translate('Atendimento') }}
                                            </span>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row class="default-margin-bottom">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-select
                                        v-model="call.situation"
                                        :items="situations"
                                        menu-props="auto"
                                        :label="labels.situacao"
                                        item-value="ID"
                                        item-text="NOME"
                                        hide-details
                                        return-object
                                        :disabled="!!user.CLIENTE_ID"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span class="d-inline-block text-truncate">
                                                <v-avatar
                                                :color="item.COR"
                                                size="18"
                                                style="margin-right: 1em;"
                                            ></v-avatar>
                                            {{ item.NOME | translate('Atendimento') }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar
                                                :color="item.COR"
                                                size="18"
                                                style="margin-right: 1em;"
                                            ></v-avatar>
                                            <span class="d-block text-truncate">{{ item.NOME | translate('Atendimento') }}</span>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row class="default-margin-bottom" v-if="!user.CLIENTE_ID">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-select
                                        v-model="call.complexity"
                                        :items="complexities"
                                        menu-props="auto"
                                        :label="labels.complexity"
                                        item-value="ID"
                                        item-text="DESCRICAO"
                                        hide-details
                                        return-object
                                        clearable
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.DESCRICAO | translate('Atendimento') }}</span>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row class="default-margin-bottom">
                                 <v-col class="noPaddingCol bolder fontSize" v-if="isCustomer">
                                    <v-autocomplete
                                        v-model="call.callResponsible"
                                        :items="acao_com_list"
                                        menu-props="auto"
                                        :label="labels.acao_com"
                                        item-text="NOME"
                                        hide-details
                                        return-object
                                        :no-data-text="labels.selectResponsibleTextNoData"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span>
                                                <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                                class="d-inline-block text-truncate"
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            {{ item.NOME }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span>{{ item.NOME }}</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="noPaddingCol bolder fontSize" v-if="isOperator">
                                    <v-autocomplete
                                        v-model="call.callResponsibleOperator"
                                        :items="acao_com_list"
                                        menu-props="auto"
                                        :label="labels.acao_com"
                                        item-text="NOME"
                                        hide-details
                                        return-object
                                        :no-data-text="labels.selectResponsibleTextNoData"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span>
                                                <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                                class="d-inline-block text-truncate"
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            {{ item.NOME }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span>{{ item.NOME }}</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row v-if="!user.CLIENTE_ID && this.isCustomer">
                                <v-col class="noPaddingCol bolder fontSize">
                                <template>
                                    <v-autocomplete
                                        :items="callPriorities"
                                        item-text="DESCRICAO"
                                        v-if="!user.CLIENTE_ID"
                                        key="ID"
                                        v-model="call.PRIORIDADE"
                                        return-object
                                        :label="labels.prioridades"
                                        clearable
                                    >
                                    </v-autocomplete>
                                </template>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.isCustomer || this.isCreating">
                                <v-col class="bolder fontSize">
                                    <span>{{'Data início' | translate('Atendimento')}}</span>
                                    <span class="red--text"><strong>*</strong></span>
                                    <date-picker v-model="call.DATA_INICIO" :placeholder="labels.data_inicio" format="DD/MM/YYYY" valueType="format" style="width: 100%;" :disabled="!!user.CLIENTE_ID"/>
                                </v-col>
                                <v-col class="bolder fontSize">
                                    <span>{{'Data limite' | translate('Atendimento')}}</span>
                                    <date-picker v-model="call.DATA_LIMITE" :placeholder="labels.data_final" format="DD/MM/YYYY" valueType="format" style="width: 100%;"/>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.isCustomer && !this.isCreating">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-autocomplete
                                        v-model="call.callUserOwner"
                                        :items="user_owner_list"
                                        menu-props="auto"
                                        :label="labels.usuario_abertura"
                                        item-text="name"
                                        hide-details
                                        return-object
                                        disabled
                                    >
                                        <template v-slot:selection="{ item }">
                                            <span>
                                                <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                                class="d-inline-block text-truncate"
                                            >
                                                <img :src="item.image ? baseUrl + item.image : defaultImage">
                                            </v-avatar>
                                            {{ item.name }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar
                                                size="22"
                                                style="margin-right: 1em;"
                                            >
                                                <img :src="item.image ? baseUrl + item.image : defaultImage">
                                            </v-avatar>
                                            <span>{{ item.name }}</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-checkbox 
                                        :label="labels.cliente_satisfeito"
                                        v-model="call.CLIENTE_SATISFEITO"
                                        true-value="S"
                                        false-value="N"
                                        :disabled="!isSituationInDeliveryProgress"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <!-- <v-row>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-text-field
                                        disabled
                                        :label="labels.titulo_negocio"
                                    ></v-text-field>
                                </v-col>
                            </v-row> -->
                            <!-- <v-row>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <template>
                                        <v-combobox
                                            disabled
                                            dense
                                            height="30px"
                                            clearable
                                            v-model="call.products"
                                            :items="products"
                                            :label="labels.busca_produtos"
                                            :search-input.sync="fastSearchProducts"
                                            @focus="changeSearchProperty('products')"
                                            item-text="NOME"
                                            return-object
                                            hide-selected
                                            chips
                                            multiple
                                        >
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <span class="pr-2">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                    >
                                                        <v-icon color="red">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </template>
                                </v-col>
                            </v-row> -->
                            <!-- <v-row>
                                <v-col>
                                    <template>
                                        <v-data-table
                                            max-height="15em"
                                            :headers="productTableHeaders"
                                            :items="call.products"
                                            hide-default-header
                                            hide-default-footer
                                            :no-data-text="labels.tableProductTextNoData"
                                            class="elevation-1"
                                        ></v-data-table>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="textRight">
                                    <span class="bolder">{{labels.valor_mensal}}:</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="textRight">
                                    <span class="bolder">{{labels.valor_negocio}}:</span>
                                </v-col>
                            </v-row> -->
                        </div>
                        <!-- <v-card-actions class="cardActions">
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder" > {{'Gerar Proposta' | translate('Atendimento')}} </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder"> {{'Gerar Contrato' | translate('Atendimento')}} </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder"> {{'Gerar Pedido' | translate('Atendimento')}} </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions> -->
                    </v-card>
                </div>
                <div class="toggleButtonDiv">
                     <v-icon right v-if="drawer" style="margin-left:-2px" color="grey" @click="drawer = !drawer" title="abrir card">
                            mdi-arrow-right-drop-circle
                        </v-icon>
                        <v-icon right v-if="!drawer" style="margin-left:-2px;" color="grey" @click="drawer = !drawer" title="Fechar card">
                            mdi-arrow-left-drop-circle
                        </v-icon>
                </div>
                <!-- </v-navigation-drawer> -->
                <!-- CHAT -->
                <v-col class="chatPage" style="overflow-y: auto;">
                    <v-tabs
                        id="tabsSendMessage"
                        class="headerTabs"
                        color="black"
                        slider-size="4"
                        v-model="tab"
                        @change="changeUserGroupTab()"
                        show-arrows
                    >
                        <v-tab class="atendimentosTab" v-for="(callGroup, i) in filteredCallGroups" 
                            :key="i" 
                            :id="`callGroup${callGroup.ID}`"
                        >
                            <v-tooltip>
                                <template v-slot:activator="{ on, attrs }">
                                    <div class=tabStyle>
                                        <div 
                                            class="tab"                                                 
                                            v-bind="attrs"
                                            v-on="on" 
                                            style="max-width: 10em; overflow-x: hidden; white-space: nowrap; text-overflow: ellipsis;"
                                        >
                                            <span class="tabFont">{{callGroup.NOME_GRUPO | translate('Atendimentos')}}</span>
                                        </div>
                                    </div>
                                </template>
                                <span class="tabFont">{{callGroup.NOME_GRUPO | translate('Atendimentos')}}</span>
                            </v-tooltip>
                        </v-tab>
                        <v-tab-item 
                            v-for="(callGroup, i) in filteredCallGroups" 
                            :key="i"
                            style="height:100%;"
                        >
                            <header class="chatHeader">
                                <span v-once style="font-size: 1em;">{{labels.titlePage}}</span>
                                <v-icon v-once style="margin:0 10px 0 6px">mdi-arrow-right</v-icon>
                                <span v-once>{{defaultCall.ASSUNTO}}</span>
                                <span style="margin-left: .5em;">
                                    <v-btn
                                        icon
                                        style="margin-left: .5em;"
                                        v-if="messageDescendingSort"
                                        @click="changeSort(false)"
                                    >
                                        <v-icon>mdi-arrow-down</v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        style="margin-left: .5em;"
                                        v-if="!messageDescendingSort"
                                        @click="changeSort(true)"
                                    >
                                        <v-icon>mdi-arrow-up</v-icon>
                                    </v-btn>
                                </span>
                            </header>
                            <body>
                                <template>
                                    <v-timeline align-top dense clipped>
                                        <v-timeline-item
                                            fill-dot
                                            class="white--text"
                                            color="#00000000"
                                            large
                                            v-if="!isHistoricTab"
                                        >
                                            <template v-slot:icon>
                                                <v-avatar>
                                                    <img :src="user.IMAGEM_PERFIL ? baseUrl + user.IMAGEM_PERFIL: defaultImage">
                                                </v-avatar>
                                            </template>
                                            <v-card class="elevation-4"
                                                :disabled="orderFinished == 'S'">
                                                <v-card-title style="padding: 10px 14px 0px 14px;">
                                                    {{user.NOME}}
                                                </v-card-title>
                                                <v-card-text style="padding: 0px 14px;">
                                                    <vue-editor
                                                        v-once
                                                        :id="`editor${callGroup.ID}`"
                                                        class="editor"
                                                        :editorToolbar="customToolbar"
                                                        style="caret-color: black;"
                                                        auto-grow
                                                        :placeholder="labels.commentPlaceholder"
                                                        :disabled="orderFinished == 'S'">
                                                    ></vue-editor>
                                                </v-card-text>
                                                <v-card-actions style="padding: 0px 10px; height: 4em;">
                                                    <div class="attachments" v-if="editMessage.attachments">
                                                        <div v-for="(attachment, i) in editMessage.attachments" :key="i" @click="downloadFile(attachment)">
                                                            <v-chip class="mr-2" style="padding:0 6px 0px 12px;" small>
                                                                <v-icon  left>
                                                                    mdi-file-download
                                                                </v-icon>
                                                                {{attachment.NOME}}

                                                                <v-btn x-small icon @click="removeAttachment($event, attachment)">
                                                                    <v-icon color="red">
                                                                        mdi-close-circle
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-chip>
                                                        </div>
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                    <v-btn icon
                                                        @click="openWindowAttachment(editMessage)"
                                                    >
                                                        <v-icon>
                                                            mdi-paperclip
                                                        </v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        depressed
                                                        class="ma-2 white--text"
                                                        fab
                                                        color="grey"
                                                        x-small
                                                        @click="openSuggestSitutationDialog(callGroup)"
                                                    >
                                                        <!-- :disabled="!newComment.length || !call.callResponsibles.length && !user.CLIENTE_ID" -->
                                                        <v-icon small>
                                                            mdi-send
                                                        </v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                                <div v-if="isOperator">
                                                    <v-row>
                                                        <v-col>
                                                            <v-autocomplete
                                                                dense
                                                                v-model="callGroup.users"
                                                                :items="callUsers"
                                                                :label="labels.usuarios_nesse_atendimento"
                                                                @blur="setAcaoComList()"
                                                                item-text="NOME"
                                                                return-object
                                                                hide-selected
                                                                chips
                                                                multiple
                                                                :disabled="!(callGroup.AMDIN_GRUPO_USUARIO_ID === user.USUARIO_ID || !callGroup.ID)"
                                                                :menu-props="{closeOnContentClick:true}"
                                                            >
                                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                                    <v-chip
                                                                        :key="JSON.stringify(item.ID)"
                                                                        v-if="item === Object(item)"
                                                                        v-bind="attrs"
                                                                        :input-value="selected.value"
                                                                        @click:close="parent.selectItem(item.value)"
                                                                        class="kndChip"
                                                                    >
                                                                        <v-avatar 
                                                                            size="22"
                                                                            style="margin-right:5px;"  
                                                                        >
                                                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                                        </v-avatar>
                                                                        <span class="pr-2">
                                                                            {{ item.NOME }}
                                                                        </span>
                                                                        <v-btn
                                                                            icon
                                                                            @click="parent.selectItem(item)"
                                                                            :disabled="item == call.responsible"
                                                                        >
                                                                            <v-icon color="red">
                                                                                mdi-close-circle
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </v-chip>
                                                                </template>
                                                                <template v-slot:[`item`]="{ item }">
                                                                    <v-avatar 
                                                                        size="22" 
                                                                        style="margin-right:5px;"  
                                                                    >
                                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                                    </v-avatar>
                                                                    <span class="pr-2">
                                                                        {{ item.NOME }}
                                                                    </span>
                                                                </template>
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="9">
                                                            <v-text-field
                                                                v-model="callGroup.DESCRICAO"
                                                                label="Nome do grupo"
                                                            >
                                                            </v-text-field>
                                                        </v-col>
                                                        <v-col 
                                                            cols="3" 
                                                            style="align-content: center; text-align: end;"
                                                        >
                                                            <v-menu
                                                                v-model="callGroup.menu"
                                                                :close-on-content-click="false"
                                                                offset-x
                                                                offset-y
                                                                left
                                                                top
                                                                id="callGroupColorMenu"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div 
                                                                        class="color-btn-col"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        <label 
                                                                            class="vue-input-label" 
                                                                            style="display: inline-block; margin-right: .3em; vertical-align: middle;" 
                                                                            for="groupColor"
                                                                        >
                                                                            Cor do grupo
                                                                        </label>
                                                                        <v-chip
                                                                            style="display: inline-block; vertical-align: middle;"
                                                                            id="groupColor"
                                                                            class="color-btn"
                                                                            :color="colorGroup"
                                                                        >
                                                                        </v-chip>
                                                                    </div>
                                                                </template>
                                                                <v-card min-width="300">
                                                                    <v-color-picker
                                                                        elevation="1"
                                                                        v-model="colorGroup"
                                                                        dot-size="25"
                                                                        mode="hexa"
                                                                        style="height: 300px;"
                                                                        swatches-max-height="160"
                                                                    ></v-color-picker>
                                                                </v-card>
                                                            </v-menu>
                                                            
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card>
                                        </v-timeline-item>
                                        <v-timeline-item
                                            hide-dot
                                            v-if="paginationMessages.length > 1"
                                        >
                                            <div class="text-center">
                                                <v-pagination
                                                    v-model="page"
                                                    :length="paginationMessages.length"
                                                    circle
                                                    :total-visible="10"
                                                ></v-pagination>
                                            </div>
                                        </v-timeline-item>
                                        <v-timeline-item 
                                            v-for="(item, i) in paginationMessages[page - 1]"
                                            :key="i"
                                            large
                                            color="#00000000"
                                            v-bind:class="{
                                                'cardAvatarHistoric': isHistoricTab
                                            }"
                                            :style="{ 
                                                '--cardAvatarHistoric-color': isHistoricTab && !(item.LOG_SISTEMA === 'S') && item.color ? item.color : defaultColor,
                                                '--cardAvatarHistoric-margin': isHistoricTab && isFirstGroupHistoricMessage(i, item) ? '2.5em 0 0 0' : '0 0 0 0'
                                            }"
                                        >
                                            <template v-slot:icon>
                                                <v-avatar>
                                                    <img :src="item.USUARIO_IMAGEM ? baseUrl + item.USUARIO_IMAGEM : defaultImage">
                                                </v-avatar>
                                            </template>
                                            <header class="chatHeader" v-if="isHistoricTab && isFirstGroupHistoricMessage(i, item)">
                                                <span style="font-size: 1em;">{{item.groupName}}</span>
                                            </header>
                                            <v-card 
                                                class="elevation-4"
                                                width="100%"
                                                v-bind:class="{ 
                                                    'cardChat': item.LOG_SISTEMA == 'S',
                                                }"
                                            >
                                                <div 
                                                    v-bind:class="{ 
                                                        'cardChat': item.LOG_SISTEMA == 'S'
                                                    }"
                                                    style="height: 1em; width: 100%;"
                                                    :style="{ 
                                                        'backgroundColor': isHistoricTab && !(item.LOG_SISTEMA === 'S') ? item.color : null
                                                    }"
                                                >
                                                </div>
                                                <v-card-title
                                                    style="padding-top: 0;"
                                                >
                                                    {{item.USUARIO_NOME}}
                                                    <v-chip 
                                                        class="chipChat" 
                                                        small 
                                                        color="green"
                                                        text-color="white"
                                                    >
                                                        <v-avatar left>
                                                            <v-icon>
                                                                mdi-calendar
                                                            </v-icon>
                                                        </v-avatar>
                                                        {{item.DATA_HORA}}
                                                    </v-chip>
                                                    <v-tooltip 
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon 
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                style="margin-left: .6em; cursor: pointer;"
                                                                class="hoverIcon"
                                                                @click="unviewMessage(item)"
                                                            >
                                                                mdi-eye-off-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>{{'Marcar como não lido' | translate('Atendimento')}}</span>
                                                    </v-tooltip>
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip v-if="showMessageViewIcon(item)" top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon 
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                color="primary"
                                                                style="margin-right:.6em"
                                                            >
                                                                mdi-check-all
                                                            </v-icon>
                                                        </template>
                                                        <span>{{'Visualizado por' | translate('Atendimento')}}</span>
                                                    </v-tooltip>
                                                    <div v-for="(view) in item.views" :key="view.USUARIO_ID">
                                                        <v-tooltip top v-if="view.VISUALIZADO == 'S' && view.USUARIO_ID != item.USUARIO_ID && view.USUARIO_ID != user.USUARIO_ID && !user.CLIENTE_ID" >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-avatar 
                                                                    size="26"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <img :src="view.USUARIO_IMAGEM ? baseUrl + view.USUARIO_IMAGEM : defaultImage">
                                                                </v-avatar>
                                                            </template>
                                                            <span>{{view.USUARIO_NOME}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                </v-card-title>
                                                <v-card-text v-if="item.LOG_SISTEMA == 'S'" class="cardCommentText" style="padding: 0px 14px;">
                                                    <v-list-item v-for="value in item.TEXTO" :key="value.label">
                                                        <v-list-item-content style="padding:0;">
                                                            <v-list-item-title>
                                                                {{value.label | translate('Atendimento')}}
                                                            </v-list-item-title>
                                                                <v-list-item-subtitle class="wraptext">{{value.oldValue}}  
                                                                    <v-icon>
                                                                        mdi-arrow-right
                                                                    </v-icon>
                                                                    {{value.newValue}}
                                                                </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-card-text>
                                                <v-card-text v-else class="cardCommentText" style="padding: 0px 14px;">
                                                    <div class="spanComment ql-editor" v-html="item.TEXTO" v-if="!item.edit"></div>
                                                </v-card-text>
                                                <v-card-actions style="padding: 0px 10px; height: 4em;">
                                                    <div class="attachments" v-if="item.attachments">
                                                        <div v-for="(attachment, i) in item.attachments" :key="i" @click="downloadFile(attachment)">
                                                            <v-chip class="mr-2" style="padding:0 6px 0px 12px;" small>
                                                                <v-icon  left>
                                                                    mdi-file-download
                                                                </v-icon>
                                                                {{attachment.NOME}}

                                                                <!-- <v-btn x-small icon @click="removeAttachment($event, attachment)">
                                                                    <v-icon color="red">
                                                                        mdi-close-circle
                                                                    </v-icon>
                                                                </v-btn> -->
                                                            </v-chip>
                                                        </div>
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                    <!-- <v-btn icon
                                                        @click="openWindowAttachment(item)"
                                                    >
                                                        <v-icon>
                                                            mdi-paperclip
                                                        </v-icon>
                                                    </v-btn> -->
                                                </v-card-actions>
                                            </v-card>
                                        </v-timeline-item>
                                        <v-timeline-item
                                            hide-dot
                                            v-if="paginationMessages.length > 1"
                                        >
                                            <div class="text-center">
                                                <v-pagination
                                                    v-model="page"
                                                    :length="paginationMessages.length"
                                                    circle
                                                    :total-visible="10"
                                                ></v-pagination>
                                            </div>
                                        </v-timeline-item>
                                    </v-timeline>
                                </template>
                            </body>
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </body>
        <input style="display:none;" type="file" id="fileDialogId" @change="addFile" multiple/>
        <v-dialog
            v-model="addUserDialog"
            width="400px"
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ 'Cadastro de Usuário' | translate('Atendimento')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="registrationDialog">
                        <v-container>
                            <v-row class="rowPadding">
                                <v-col cols="12">
                                    <v-text-field
                                        autofocus
                                        :loading="loading"
                                        v-model="editedItem.NOME"
                                        :label="labels.nome"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="rowPadding">
                                <v-col cols="12">
                                    <v-text-field
                                        :loading="loading"
                                        v-model="editedItem.EMAIL"
                                        :label="labels.email"
                                        :rules="[rules.email]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row  v-if="typeNewUser == 'requester'" style="height: 4em; margin-top:0; margin-left: .5em;">
                                <v-col cols="12" style="padding-top:4px;">
                                    <v-radio-group
                                        v-model="editedItem.type"
                                        row
                                    >
                                        <v-radio
                                            :label="labels.operador"
                                            value="P"
                                        ></v-radio>
                                        <v-radio
                                            :label="labels.cliente"
                                            value="C"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row v-if="typeNewUser == 'requester'" >
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <v-select
                                        v-model="call.client"
                                        :items="[call.client]"
                                        menu-props="auto"
                                        :label="labels.cliente"
                                        hide-details
                                        return-object
                                        readonly
                                        :disabled="editedItem.type == 'P'"
                                    >
                                        <template v-slot:selection>
                                            <v-chip
                                                :input-value="call.client"
                                                class="kndChip"
                                            >
                                                <v-avatar 
                                                    size="22"
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="call.client.IMAGEM_PERFIL ? baseUrl + call.client.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ call.client.NOME }}
                                                </span>
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="closeDialog"
                        >
                            {{'Cancelar' | translate('Atendimento')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="dialogSuccess"
                            :disabled="validateForm()"
                        >
                            {{'Salvar' | translate('Atendimento')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog
            v-model="callsLinkDialog" 
            class="mx-auto"
            max-width="400"   
            persistent
        >
            <v-card>
                <v-card-title>{{'Vincula Atendimento' | translate('Atendimento')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="bodyCallLink">
                    <v-autocomplete
                        v-model="linksToApply"
                        :items="callsToLink"
                        return-object
                        :label="labels.buscar"
                        item-text="FILTRO"
                        item-value="ID"
                        multiple
                        :loading="loadingCallsLink"
                    >
                        <template v-slot:no-data>
                            {{labels.no_data}}
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-chip
                                v-bind="attr"
                                :input-value="selected"
                                color="#888888"
                                class="white--text"
                                v-on="on"
                            >
                                <span v-text="item.ID"></span>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <div style="display: flex; align-items: center;">
                                <v-chip
                                    color="#888888"
                                    size="20"
                                    class="white--text"
                                >
                                    <span v-text="item.ID"></span>
                                </v-chip>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </div>
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="cancelChangeLinks()"
                    >
                        <v-icon x-small>
                            mdi-close
                        </v-icon>
                        {{'Cancelar' | translate('Atendimento')}}
                    </v-btn>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="applyChangeLinks()"
                    >
                        <v-icon x-small>
                            mdi-check
                        </v-icon>
                        {{'Ok' | translate('Atendimento')}}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-dialog
            v-model="ordersLinkDialog" 
            class="mx-auto"
            max-width="400"   
        >
            <v-card>
                <v-card-title>{{'Vincular Pedidos' | translate('Atendimento')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="bodyCallLink">
                    <v-autocomplete
                        v-model="orderLinksToApply"
                        :items="orders"
                        :label="labels.buscar"
                        item-text="ID"
                        return-object
                        :loading="loadingOrders"
                    >
                        <template v-slot:no-data>
                            {{labels.no_data}}
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-chip
                                v-bind="attr"
                                :input-value="selected"
                                color="#888888"
                                class="white--text"
                                v-on="on"
                            >
                                <span v-text="item.ID"></span>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <div style="display: flex; align-items: center;">
                                <v-chip
                                    color="#888888"
                                    size="20"
                                    class="white--text"
                                >
                                    <span v-text="item.ID"></span>
                                </v-chip>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </div>
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="cancelChangeOrderLinks()"
                    >
                        <v-icon x-small>
                            mdi-close
                        </v-icon>
                        {{'Cancelar' | translate('Atendimento')}}
                    </v-btn>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="applyChangeOrderLinks()"
                    >
                        <v-icon x-small>
                            mdi-check
                        </v-icon>
                        {{'Ok' | translate('Atendimento')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="saveDialog"
            width="800"
            persistent
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ 'Situações' | translate('Situacaoes')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        outlined
                                        :label="labels.technicalDetail"
                                        v-model="technicalDetail"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        :label="labels.cep"
                                        :items="ceps"
                                        v-model="finalDialogData.cep"
                                        return-object
                                        item-text="DESCRICAO"
                                        item-value="ID"
                                    >
                                        <template #label>
                                            <span>{{ labels.cep }}</span> 
                                            <span class="red--text"><strong>*</strong></span>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.DESCRICAO | translate('Atendimento') }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <span>{{ item.DESCRICAO | translate('Atendimento') }}</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        :label="'Produto sugerido' | translate('Atendimento')"
                                        :items="product_modules"
                                        v-model="finalDialogData.suggestedProduct"
                                        dense
                                        height="30px"
                                        clearable
                                        :disabled="this.isOperator"
                                        item-text="DESCRICAO"                                      
                                        return-object
                                        :menu-props="{closeOnContentClick:true}"                                      
                                    >
                                        <template #label>
                                            <span>{{ 'Produto sugerido' | translate('Atendimento') }}</span> 
                                            <span class="red--text"><strong>*</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-checkbox :label="'Encerrado por falta de interação' | translate('Atendimento')"
                                              v-model="finalDialogData.dueToInactivity"
                                              true-value="S"
                                              false-value="N"
                                    >
                                  </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="closeSaveDialog"
                        >
                            {{'Cancelar' | translate('Atendimento')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="successSaveDialog"
                            :disabled="isCompletedModalSaveButtonDisabled"
                        >
                            {{'Salvar' | translate('Atendimento')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog
            v-model="changeSectionDialog"
            width="800"
            persistent
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ 'Setor alterado' | translate('Situacaoes')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        outlined
                                        :label="labels.reasonForChange"
                                        v-model="call.sectionChangeReason"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="changeSectionDialogReject(labels.processStopped); closeChangeSectionDialog()"
                        >
                            {{'Cancelar' | translate('Atendimento')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="changeSectionDialogResolve(); closeChangeSectionDialog()"
                            :disabled="!call.sectionChangeReason"
                        >
                            {{'Salvar' | translate('Atendimento')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <template>
        <div class="text-center">
            <v-dialog
                v-model="confirmationNewOrder"
                width="500"
            >
            <v-card>
                <v-card-title class="text-h5">
                </v-card-title>
                <v-card-text class="text-h6 black--text">
                    Deseja criar um novo pedido?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red"
                    text
                    @click="confirmationNewOrder = false"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="green"
                    text
                   @click="newOrderPage()"
                >
                    Sim
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-dialog
                v-model="controlProductivityDialog"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h5">
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        Deseja parar de trabalhar no atendimento {{this.lastCallIdAccessed}} e começar a trabalhar nesse?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="closeControlProductivityModal()"
                    >
                        Não
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        @click="stopPreviousAndStartWorkingInThisCall()"
                    >
                        Sim
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="inactivityDialog"
                width="500"
                persistent
            >
                <v-card>
                    <v-card-title class="text-h5">
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        Atendimento pausado | Você ainda está trabalhando nesse atendimento?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green"
                        text
                        @click="startWorkingInThisCall(); closeInactiveModal();"
                    >
                        Sim
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="suggestSituationDialog"
                width="500"
                persistent
            >
                <v-card>
                    <v-card-title class="text-h5">
                        Situações possíveis para o atendimento
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        <v-select
                            v-model="suggestedSituationSelected"
                            :items="call.situation.situations"
                            menu-props="auto"
                            :label="labels.situacao"
                            item-value="ID"
                            item-text="NOME"
                            hide-details
                            return-object
                            :disabled="!!user.CLIENTE_ID"
                        >
                            <template v-slot:selection="{ item }">
                                <span class="d-inline-block text-truncate">
                                    <v-avatar
                                    :color="item.COR"
                                    size="18"
                                    style="margin-right: 1em;"
                                ></v-avatar>
                                {{ item.NOME | translate('Atendimento') }}</span>
                            </template>
                            <template v-slot:[`item`]="{ item }">
                                <v-avatar
                                    :color="item.COR"
                                    size="18"
                                    style="margin-right: 1em;"
                                ></v-avatar>
                                <span class="d-block text-truncate">{{ item.NOME | translate('Atendimento') }}</span>
                            </template>
                        </v-select>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="closeSuggestSituationDialog()"
                    >
                        Fechar
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        @click="addSituationMessage()"
                        :loading="loadingSuggestedSituation"
                    >
                        Continuar
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="imageDialog"
                content-class="imageFullVisibility"
            >
                <div ref="imageFullVisibility"></div>
            </v-dialog>
        </div>
        </template>
    </v-container>
</template>

<script>
import getCallById from '../../../src/app/atendimento/getCallById'
import { createNamespacedHelpers } from 'vuex'
import translate from '../../../src/plugins/translate'
import { VueEditor } from 'vue2-editor'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import getAllCallSituations from '../../../src/app/situacaoAtendimento/getSituations'
import getAllCallComplexities from '../../../src/app/atendimento/getAllCallComplexities'
import getClientsByCompanyIdAndName from '../../../src/app/cliente/loadAll'
import getProductsByCompanyIdAndName from '../../../src/app/produto/getProductsByCompanyIdAndName'
import getProductModulesByCompanyIdAndName from '../../../src/app/produto/getProductModulesByCompanyIdAndName'
import loadAllResponsible from '../../../src/app/responsavelAtendimento/loadAllResponsible'
import loadAllRequesters from '../../../src/app/solicitanteAtendimento/loadAllRequesters'
import addCall from '../../../src/app/atendimento/addCall'
import getPriorities from '../../../src/app/atendimento/getPriorities'
import updateCall from '../../../src/app/atendimento/updateCall'
import callEmail from '../../../src/app/atendimento/callEmail'
import getCeps from '../../../src/app/atendimento/getCeps'
import addNewMessage from '../../../src/app/mensagemAtendimento/addMessage'
import loadAllMessagesByCallId from '../../../src/app/mensagemAtendimento/loadAllByCallId'
import updateViewsByCallId from '../../../src/app/mensagemAtendimento/statusMensagemAtendimento/updateViewsByCallId'
import getAllOrders from '../../../src/app/pedido/getAllOrdersToLink'
import getAllCallsByCompanyIdAndUserId from '../../../src/app/atendimento/getAllCallsByCompanyIdAndUserId'
import reportCall from '../../../src/reports/reportCall'
import moment from 'moment'
import getClientById from '../../../src/app/cliente/getClientById'
import getFile from '../../../src/app/downloadArquivo/getFile'
import { distinct } from '../../../src/app/util/index'
import insertCallGroup from '../../../src/app/grupoUsuarioAtendimento/insert'
import updateCallGroup from '../../../src/app/grupoUsuarioAtendimento/update'
import getLastUserAccesInCall from '../../../src/app/controleProdutividade/getLastUserAccesInCall'
import insertUserAccessInCall from '../../../src/app/controleProdutividade/insertUserAccessInCall'
import { connectSocket, disconnectSocket } from '../../../src/plugins/socketIoControlProductivity'
import getCallCharge from '../../../src/app/atendimento/getCallCharge'
import updateViewsById from '../../../src/app/mensagemAtendimento/statusMensagemAtendimento/updateViewsById'
import loadAllSections from '../../../src/app/setor/loadAllSections'

const user = createNamespacedHelpers('user')
const interceptor = createNamespacedHelpers('interceptor')

export default {
    name: 'Atendimento',
    components: {VueEditor, DatePicker},
    data() {
        return {
            orderFinished : 'N',
            confirmationNewOrder : false,
            userType : '',
            newComment: '',
            expand: false,
            editMessage:{attachments:[]},
            defaultCall:{},
            acao_com_list : [],
            orderLinksToApply: null,
            call:{
                relatedCalls:[],
                relatedOrders:[],
                views:[],
                callRequesters:[],
                callResponsibles:[],
                callInternalResponsibles:[],
                DATA_INICIO: null,
                DATA_LIMITE: null,
                situation: {},
                PRIORIDADE : {},
                section: {},
                callGroups: []
                // client:{}
            },
            filters: {
                default:{
                    description:'',
                    selected:[],
                    rows:[]
                }
            },
            loading: true,
            search: null,
            imageTime: new Date().getTime(),
            defaultImage: require('../../../src/assets/user.png'),
            logoClient: require('../../../src/assets/empresas/logoPGD.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            labels: {
                cliente: translate('Cliente', 'Atendimento'),
                solicitantes: translate('Solicitantes', 'Atendimento'),
                commentPlaceholder: translate('Digite aqui...', 'Atendimento'),
                responsaveis: translate('Responsáveis','Atendimento'),
                responsaveis_internos: translate('Responsáveis Internos','Atendimento'),
                data_inicio: translate('Data Inicio','Atendimento'),
                data_final: translate('Data Final','Atendimento'),
                acao_com: translate('Ação Com','Atendimento'),
                situacao: translate('Situação','Atendimento'),
                complexity: translate('Complexidade','Atendimento'),
                titulo_negocio: translate('Título do Negócio','Atendimento'),
                busca_produtos: translate('Buscar Produtos','Atendimento'),
                tableProductTextNoData: translate('Nenhum produto selecionado...', 'Atendimento'),
                titlePage:  translate('Atendimento Detalhamento', 'Atendimento'),
                valor_mensal: translate('Valor Mensal do Negócio', 'Atendimento'),
                valor_negocio: translate('Valor do Negócio', 'Atendimento'),
                selectResponsibleTextNoData: translate('Nenhum responsável selecionado...', 'Atendimento'),
                assunto: translate('Assunto', 'Atendimento'),
                operador: translate('Operador', 'Atendimento'),
                nome: translate('Nome', 'Atendimento'),
                email: translate('Email', 'Atendimento'),
                buscar: translate('Buscar', 'Atendimento'),
                no_data: translate('Nenhum Valor Encontrado', 'Atendimento'),
                pedido: translate('Pedido', 'Atendimento'),
                product_module: translate('Produto / Módulo', 'Atendimento'),
                ra_number: translate('Número do atendimento', 'Atendimento'),
                prioridades: translate('Prioridade', 'Atendimento'),
                usuarios_nesse_atendimento: translate('Usuários nesse atendimento', 'Atendimento'),
                cep: translate('Controle Estatístico de Processo', 'Atendimento'),
                usuario_abertura: translate('Iniciado por:', 'Atendimento'),
                cliente_satisfeito: translate('Cliente satisfeito', 'Atendimento'),
                responsibleSection: translate('Setor responsável', 'Atendimento'),
                technicalDetail: translate('Detalhamento técnico', 'Atendimento'),
                reasonForChange: translate('Motivo da mudança', 'Atendimento'),
                processStopped: translate('Operação cancelada', 'Atendimento'),
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Atendimento'),
                email: (val) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(val) || translate('Email Invalido!', 'Atendimento')
                }
            },
            customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }, { background: [] }]
            ],
            fastSearchProducts: null,
            fastSearchClients: null,
            fastSearchResponsibles: null,
            fastSearchRequesters: null,
            fastSearchProductModules: null,
            searchProperty: null,
            drawer : false,
            searchProperties: {},
            productTableHeaders:[
                { text: translate('Produto', 'Atendimento'), value: 'NOME', width: '40%', align:'center'},
                { text: translate('Qtd.', 'Atendimento'), value: 'QUANTIDADE', width: '10%' },
                { text: translate('Mensal', 'Atendimento'), value: 'MENSAL', width: '15%' },
                { text: translate('Horas', 'Atendimento'), value: 'HORAS', width: '15%', align:'center' },
                { text: translate('Valor', 'Atendimento'), value: 'VALOR', width: '20%', align:'center'}
            ],
            situations:[],
            products:[],
            product_modules: [],
            callPriorities : [],
            clients:[],
            ceps:[],
            responsibles:[],
            requesters:[],
            callsToLink:[],
            callResponsibles:[],
            callRequesters:[],
            requestsmethods: {
                clients: getClientsByCompanyIdAndName,
                products: getProductsByCompanyIdAndName,
                responsibles: loadAllResponsible,
                requesters: loadAllRequesters,
                product_modules: getProductModulesByCompanyIdAndName
            },
            messages:[],
            editedItem: {type:'P'},
            addUserDialog: false,
            dialogSuccess: null,
            typeNewUser: null,
            callsLinkDialog: false,
            linksToApply: [],
            orders: [],
            ordersLinkDialog: false, 
            saveDialog: false,
            technicalDetail: null,
            finalDialogData:{
                suggestedProduct:null,
                cep:null,
                dueToInactivity: false
            },
            callTypes: {
                customer: 'customer',
                operator: 'operator'
            },
            isOperator: false,
            isCustomer: false,
            callType: null,
            defaultType: null,
            tab: null,
            actualGroupMessages: [],
            lastUpdatedCallGroupId: null,
            accessType: {
                in: 'E',
                out: 'S'
            },
            lastCallIdAccessed: null,
            controlProductivityDialog: false,
            callCharge: {},
            colorGroup: '',
            messageDescendingSort: true,
            defaultColor: 'white',
            customerMessages: [],
            isFirstMessageFromACustomer: false,
            user_owner_list: [],
            page: 1,
            sections: [],
            complexities: [],
            suggestSituationDialog: false,
            chosenCallGroup: {},
            suggestedSituationSelected: {},
            loadingSuggestedSituation: false,
            inactivityDialog: false,
            imageDialog: false,
            succcessSaveDialogCb: null,
            succcessSaveDialogParams: null,
            changeSectionDialog: null,
            changeSectionDialogReject: null,
            changeSectionDialogResolve: null,
            loadingCallsLink: false,
            loadingOrders: false
        }
    },
    watch: {
        callResponsiblesComputed(val){
            if(val.length > 1){
                this.call.callResponsibles = [val[val.length - 1]]
            }
        }
        // async fastSearchProducts(val) {
        //     if( val && val.length >= 2) await this.getFilterValues(val)
        // },
        // async fastSearchProductModules(val) {
        //     if(this.searchProperty === 'product_modules') await this.getFilterValues(val)
        // },
        // async fastSearchClients(val) {
        //     if(this.searchProperty === 'clients') await this.getFilterValues(val)
        // },
        // async fastSearchResponsibles(val) {
        //     if(this.searchProperty === 'responsibles') await this.getFilterValues(val)
        // },
        // async fastSearchRequesters(val) {
        //     if(this.searchProperty === 'requesters') await this.getFilterValues(val)
        // }
    },
    methods: {
        openCallsLinkModal(){
            this.callsLinkDialog = true
            if(!this.callsToLink.length) this.getAllCallsToLink()
        },
        openOrderLinkDialog(){
            this.ordersLinkDialog = true
            if(!this.orders.length) this.loadAllOrders()
        },
        changeUserGroupTab(){
            if(!this.tab && this.tab != 0) return setTimeout(this.changeUserGroupTab, 500)

            const callGroup = this.call.callGroups[this.tab]
            this.actualGroupMessages = callGroup.messages

            this.$nextTick(this.setFullVisibilityOnImages)

            this.colorGroup = callGroup.COR
        },
        setFullVisibilityOnImages(){
            const self = this
            const editors = document.querySelectorAll('.ql-editor')
            editors.forEach((editor) => {
                const images = editor.querySelectorAll('img')
                images.forEach((img) => {
                    img.style.cursor = 'pointer'
                    img.ondblclick = () => {
                        self.imageDialog = true
                        self.$nextTick(() => {
                            self.$refs.imageFullVisibility.innerHTML = ''
                            const imageCopy = img.cloneNode(true)
                            imageCopy.height = imageCopy.naturalHeight
                            imageCopy.width = imageCopy.naturalWidth
                            imageCopy.style.cursor = 'default'
                            self.$refs.imageFullVisibility.onclick = () => {
                                self.imageDialog = false
                            }
                            self.$refs.imageFullVisibility.appendChild(imageCopy)
                        })
                    }
                })
            })
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        async getAllProdModules(){
            this.loading=true
            await getProductModulesByCompanyIdAndName().then(response => {
                this.product_modules = response.data
            })
        },
        openConfirmationNewOrder(){
            this.confirmationNewOrder = true
        },
        closeConfirmationDialog(){
            this.confirmationNewOrder = false
        },
        unlinkOrder(){
            this.call.PEDIDO = null
            this.orderLinksToApply = null
        }
        ,
        goToOrder(){
            if(!(this.defaultCall.PEDIDO == this.call.PEDIDO) || this.user.CLIENTE_ID) return 
            this.$router.push('/pedido/' + this.call.PEDIDO)
        },
        newOrderPage(){
            const produtoId = this.callCharge.PRODUTO_ID 
                ? { ID: this.callCharge.PRODUTO_ID, DESCRICAO: this.callCharge.PRODUTO_DESCRICAO } 
                : this.call.product_module ? this.call.product_module : {}

            this.$router.push({name : 'Pedido', params : {newOrder : {
                callNumber : this.call.ID ? this.call.ID : null,
                clientCNPJ : this.call.client.CNPJ ? this.call.client.CNPJ : null,
                solicitante : this.call.callRequesters[0].NOME ?  this.call.callRequesters[0].NOME : null,
                emailResponsavel : this.call.callResponsible.EMAIL ? this.call.callResponsible.EMAIL : null,
                produtoId : produtoId,
                orderType: { CODIGO: this.callCharge.TIPO_PEDIDO, NOME: this.callCharge.TIPO_PEDIDO_DESCRICAO },
                resourceId: { ID: this.callCharge.RECURSO_ID, DESCRICAO: this.callCharge.RECURSO_DESCRICAO },
                orderClassification: { ID: this.callCharge.SERVICO_CLASSIFICACAO_ID, DESCRICAO: this.callCharge.SERVICO_CLASSIFICACAO_DESC },
                paymentConditionId: { ID: this.callCharge.CONDICAO_PGTO_ID, CONDICAO_PAGAMENTO: this.callCharge.CONDICAO_PGTO_DESCRICAO },
                appointedHours: this.callCharge.QTD_HORAS_APONTADAS,
                requestItems: this.callCharge.SERVICO_SOLICITADO,
                subject: this.callCharge.ASSUNTO,
                situation: this.callCharge.ID ? 'Confirmado' : null,
                toInvoice: this.callCharge.ID ? 'S': null
            }}})
        },
        getGeneralCallGroup(messages){
            return { 
                AMDIN_GRUPO_USUARIO_ID: null,
                ID: null,
                NOME_GRUPO: translate('Geral', 'Atendimento'),
                messages: messages ? messages : [],
                users: [],
                COR: '#ffffff'
            }
        },
        getAllMessagesCallGroup(messages){
            return {
                AMDIN_GRUPO_USUARIO_ID: null,
                ID: null,
                NOME_GRUPO: translate('Histórico', 'Atendimento'),
                messages: messages ? messages : [],
                users: [],
                ID_GRUPO: 1
            }
        },
        async getCall(){
            await getCallById(this.callId, this.callType)
                .then(function(response){
                    this.call = response.data.call
                    this.call.technicalDetail = (response.data.messages.find(cm => cm.DETALHAMENTO_TECNICO === 'S') || { TEXTO: [{newValue: null}] }).TEXTO[0].newValue
                    this.defaultCall = Object.assign({}, response.data.call)
                    this.defaultCall.relatedCalls = response.data.call.relatedCalls.map(rc => ({
                        ID: rc.ID,
                        ASSUNTO: rc.ASSUNTO,
                        REMOVE: rc.REMOVE
                    }))
                    this.messages = [].concat(response.data.messages)
                    this.customerMessages = [].concat(response.data.customerMessages)

                    const firstMessage = this.messages.concat(this.customerMessages).sort((a, b) => {
                        const aDate = new Date(a.DATA_HORA_DATE).getTime()
                        const bDate = new Date(b.DATA_HORA_DATE).getTime()
                        return aDate - bDate
                    })[0]
                    this.isFirstMessageFromACustomer = firstMessage && firstMessage.CLIENTE_ID

                    this.call.callGroups = [this.getGeneralCallGroup(this.messages)].concat(this.call.callGroups).concat(this.getAllMessagesCallGroup(this.allMessages))
                    const lastUpdatedCallGroupIndex = this.call.callGroups.findIndex(cg => cg.ID === this.lastUpdatedCallGroupId)
                    if(lastUpdatedCallGroupIndex) this.tab = lastUpdatedCallGroupIndex
                    this.lastUpdatedCallGroupId = null

                    this.changeUserGroupTab()

                    this.updateViewMessages()
                }.bind(this))
                .catch(function(err){
                    if(err.response && err.response.data && err.response.data.code === 6) setTimeout(() => this.$router.push('/atendimentos'), 500)
                    else throw err
                })
        },
        async updateViewMessages(){
            await updateViewsByCallId({userId:this.user.USUARIO_ID, callId:this.call.ID, factoryUserId:this.user.EMPRESA_USUARIO_ID, callType: this.callType})
        },
        unviewMessage(item){
            updateViewsById({
                callMessageId: item.ID, 
                userId:this.user.USUARIO_ID, 
                factoryUserId:this.user.EMPRESA_USUARIO_ID 
            })
        },
        getUsersToNotify(){
            let requestersIds = []

            for(let i = 0; i < this.call.callRequesters.length; i++){
                requestersIds.push(this.call.callRequesters[i].USUARIO_ID)
            }

            let responsiblesIds = []

            for(let i = 0; i < this.call.callResponsibles.length; i++){
                responsiblesIds.push(this.call.callResponsibles[i].USUARIO_ID)
            }

            let callRequesters = this.call.callRequesters.filter(getRequestersByCallType.bind(this))
            let notifyUsers = [].concat([...this.call.callResponsibles, ...callRequesters, ...this.call.callInternalResponsibles])
    
            return distinct(notifyUsers, 'USUARIO_ID')

            //#region Internal functions
            function getRequestersByCallType(cr){
                const isCrOperator = !cr.CLIENTE_ID
                return (this.isOperator && isCrOperator) || this.isCustomer
            }
            //#endregion

        },
        checkActualLength(str){
            let step = str.replace('<p>','')
            let step1 = step.replace('</p>','')
            let step2 = step1.replace(/ /g, '')
            let step3 = step2.replace('<br>','')
            return step3.length
        }
        ,
        async manageCallGroup(callGroup){
            const types = {
                create: 'create',
                update: 'update'
            }

            const type = !callGroup.ID
                ? types.create
                : types.update 

            const sendUsers = callGroup.users.filter(u => {
                if(callGroup.AMDIN_GRUPO_USUARIO_ID) return u.USUARIO_ID != callGroup.AMDIN_GRUPO_USUARIO_ID
                else return u.USUARIO_ID != this.user.USUARIO_ID
            })
            const adminUserId = callGroup.AMDIN_GRUPO_USUARIO_ID
                ? callGroup.AMDIN_GRUPO_USUARIO_ID
                : this.user.USUARIO_ID
            
            switch (type) {
                case types.create:
                    try{
                        const response = await insertCallGroup({
                            callGroup: {
                                users: sendUsers,
                                adminUserId: adminUserId,
                                description: callGroup.DESCRICAO,
                                color: this.colorGroup
                            },
                            callId: this.call.ID
                        })
                        return response.data.callGroupId
                    } catch(err){
                        return sendErrorCallGroupId.bind(this)()
                    }
                case types.update:
                    try{
                        await updateCallGroup({
                            callGroup: {
                                callGroupId: callGroup.ID,
                                users: sendUsers,
                                adminUserId: adminUserId,
                                description: callGroup.DESCRICAO,
                                color: this.colorGroup
                            },
                            callId: this.call.ID
                        })
                        return callGroup.ID
                    } catch(err){
                        return sendErrorCallGroupId.bind(this)()
                    }
            }
            //#region Internal functions
            function sendErrorCallGroupId(){
                if(this.error && this.error.response && this.error.response.data){
                    const isExistingGroup = this.error.response.data.code === 7
                    return isExistingGroup
                        ? this.error.response.data.callGroupId
                        : null
                } else setTimeout(sendErrorCallGroupId, 100)
            }
            //#endregion
        },
        getCallGroupId(){
            const hasCallGroup = this.call && this.call.callGroups && this.call.callGroups[this.tab]
            return hasCallGroup 
                ? this.call.callGroups[this.tab].ID 
                : null
        },
        getNewComment(){
            const editor = document.getElementById(`editor${this.getCallGroupId()}`)
            const images = editor.querySelectorAll('img')
            images.forEach((img) => {
                img.width = img.clientWidth
                img.height = img.clientHeight
            })
            return editor.firstElementChild.innerHTML
        },
        setNewComment(value){
            const editor = document.getElementById(`editor${this.getCallGroupId()}`)
            if(!editor) return setTimeout(this.setNewComment, 500)
            editor.firstElementChild.innerHTML = value ? value : ''
        },
        openSuggestSitutationDialog(callGroup){
            this.chosenCallGroup = {}
            this.chosenCallGroup = callGroup
            if(this.getUserType() === 'customer' || this.isOperator) this.addMessage(this.chosenCallGroup)
            else this.suggestSituationDialog = true
        },
        closeSuggestSituationDialog(){
            this.suggestSituationDialog = false
        },
        async addSituationMessage(){
            let lastSituation = null

            try {
                if(!this.suggestedSituationSelected.ID){
                    this.$notify.warning({
                        title: translate('Atenção' , 'Atendimento'),
                        message: translate('É necessário escolher uma situação!', 'Atendimento')
                    });
                    return
                }

                if(this.shouldOpenChangeSectionDialog) await this.openChangeSectionDialog()
    
                lastSituation = this.call.situation
                this.call.situation = this.suggestedSituationSelected
                
                this.loadingSuggestedSituation = true
                if(this.$route.query.id){
                    const noReload = true
                    this.validateMessage()
                    await this.updateCall(noReload)
                } 
                this.loadingSuggestedSituation = false                
    
                if(this.shouldOpenSaveDialog){
                    this.succcessSaveDialogCb = this.addMessage
                    this.succcessSaveDialogParams = this.chosenCallGroup
                    this.openSaveDialog()
                } else {
                    this.addMessage(this.chosenCallGroup)
                }

                this.closeSuggestSituationDialog()
            } catch (error) {
                this.loadingSuggestedSituation = false
                this.call.situation = lastSituation
            }
        },
        validateMessage(){
            const newComment = this.getNewComment()
            if(this.disableSave() || this.checkActualLength(newComment) == 0){
                const errorMessage = translate('Por favor verifique os campos obrigatórios', 'Atendimento')
                this.$notify.error({
                    title: translate('Erro' , 'KndError'),
                    message: errorMessage,
                })
                throw new Error(errorMessage)
            }
        },
        async addMessage(callGroup){
            try {
                const newComment = this.getNewComment()
                this.validateMessage()

                this.loading = true

                const isCallGroup = !!callGroup.users.length
                if(isCallGroup){
                    callGroup.ID = await this.manageCallGroup(callGroup)
                    this.lastUpdatedCallGroupId = callGroup.ID
                } 

                let notifyUsers = isCallGroup
                    ? callGroup.users 
                    : this.getUsersToNotify()

                let message = {
                    USUARIO_ID: this.user.USUARIO_ID,
                    TEXTO: newComment,
                    ATENDIMENTO_ID: this.call.ID,
                    notifyUsers: notifyUsers,
                    attachments: this.editMessage.attachments,
                    TIPO: this.callType || this.defaultType,
                    callGroup: callGroup
                }

                message.notifyUsers = message.notifyUsers.filter(function(notifyUser){
                    return notifyUser && notifyUser.USUARIO_ID != message.USUARIO_ID
                })

                const addNewMessageResponse = await addNewMessage(message)
                if(this.user.CLIENTE_ID && this.call.callResponsibles.length){
                    await this.getSituations()
                    const afterCustomerReplySituation = this.situations.find(s => s.POS_RESPOSTA_CLIENTE === 'S') || {}
                    this.call.situation = afterCustomerReplySituation
                    await this.updateCall()
                }
                let addCallResponse = null

                if(addNewMessageResponse.data.code === 5){
                    this.call.EMPRESA_ID = this.user.EMPRESA_ID
                    this.call.USUARIO_ID = this.user.USUARIO_ID
                    addCallResponse = await addCall(this.call)
                    message.ATENDIMENTO_ID = addCallResponse.data.callId
                    await addNewMessage(message)
                    this.callId = addCallResponse.data.callId
                    this.callType = this.defaultType
                } 
                this.clearVueEditorField()
                this.editMessage = {attachments:[]}
                await this.getCall()
                callEmail({ATENDIMENTO_ID : this.call.ID, callType: this.callType, callGroupId: callGroup.ID})
                this.loading = false
                if(addCallResponse && addCallResponse.data.callId){
                    this.$router.push({
                        path: '/atendimento',
                        query: {
                            id: addCallResponse.data.callId,
                            callType: this.defaultType
                        }
                    }).then(() => {
                        window.location.reload();
                    });
                }
                this.orderFinished = this.call.situation.FINAL
                
            } catch (error) {
                this.loading = false
                throw error
            }
        },
        clearVueEditorField(){
            this.setNewComment('')
            let vueEditors = document.getElementsByClassName('editor')
            for(let ve of vueEditors) ve.lastElementChild.firstElementChild.innerHTML = ''
        }
        ,
        async getCepList(){
            await getCeps().then(response => {
                this.ceps = response.data
            })
        }
        ,
        async loadAllMessages() {
            this.loading = true
            await loadAllMessagesByCallId(this.callId)
                .then(function(response){
                    if(response.data){
                        this.messages = [].concat(response.data)
                        this.updateViewMessages()
                    }
                }.bind(this))
        }, 
        editItem(item){
            this.$nextTick(function(){
                item.edit = true
            })
        },
        createFile(array, file) {
            var reader = new FileReader()
            reader.onload = (event) => {
                array.push({NOME:file.name, DIRETORIO:'./public/anexoMensagemAtendimento', file:event.target.result})
            }
            reader.readAsDataURL(file)
        },
        expandMenu(event){
            event.stopPropagation()
            this.expand = !this.expand
            event.target.parentElement.classList.toggle('active')
            event.target.classList.toggle('active')
            let topMenuCard = document.getElementById('topMenuCard')
            topMenuCard.classList.toggle('active')
        },
        gotoCall(callId){
            this.$router.push({
                path: '/atendimento',
                query: {
                    id: callId,
                    callType: this.callType
                }
            }).then(() => {
                window.location.reload();
            });
        },
        // async changeSearchProperty(filter) {
        //     this.searchProperty = filter
        //     await this.getFilterValues()
        // },
        // async getFilterValues(stringSearch) {
        //     var self = this
        //     let filter = {
        //         companyId: self.user.EMPRESA_ID,
        //         clientId: self.call.client ? self.call.client.ID : null,
        //         name: stringSearch,
        //         customerUserId: this.user.CLIENTE_ID
        //     }
        //     await this.requestsmethods[this.searchProperty](filter)
        //         .then(function(response){
        //             this[this.searchProperty] = response.data
        //         }.bind(this))
        // },
        putSituation(){
            if(!this.call.ID){
                for(const situation of this.situations){
                    if(situation.PADRAO == 'S'){
                        this.call.situation = situation
                    }
                }
            }

            this.orderFinished = this.call.situation ? this.call.situation.FINAL : null
        },
        async getSituations(){
            this.loading = true
            return await getAllCallSituations({companyId:this.user.EMPRESA_ID, active:'S'})
                .then(function(response){
                    this.situations = response.data
                }.bind(this))
        },
        async getComplexities(){
            this.loading = true
            return await getAllCallComplexities()
                .then(function(response){
                    this.complexities = response.data
                }.bind(this))
        },
        addClient(){
            this.clients.push({NOME: this.fastSearchClients, new: true})
        },
        addResponsible(){
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            if(this.editedItem.type == 'C') this.editedItem.client = this.call.client
            this.call.callResponsibles.push(Object.assign(this.editedItem, {IMAGEM_PERFIL: null, new: true}))
            this.closeDialog()
        },
        addRequester(){
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            if(this.editedItem.type == 'C') this.editedItem.client  = this.call.client
            this.call.callRequesters.push(Object.assign(this.editedItem, {IMAGEM_PERFIL: null, new: true}))
            this.closeDialog()
        },
        addUser(subject){
            this.typeNewUser = subject
            this.dialogSuccess = subject == 'requester' ? this.addRequester : this.addResponsible
            this.addUserDialog = true
            this.setCallResponsibles()
        },
        goBack(){
            this.$router.push(localStorage.getItem('backToUrl') || '/atendimentos')
        },
        openWindowAttachment(){
            var inputFile = document.getElementById('fileDialogId')
            inputFile.click()
        },
        addFile(event){
            if(!event.target.files || !event.target.files.length) return
            var files = event.target.files
            for(var i = 0; i < files.length; i++){
                this.createFile(this.editMessage.attachments, files[i])
            }
        },
        removeAttachment(event, item){
            event.stopPropagation()
            this.editMessage.attachments = this.editMessage.attachments.filter(function(attachment) {
                return attachment != item
            })

        },
        async downloadFile(data){
            const isStorage = data.DIRETORIO.includes('storage')
            const splittedName = data.NOME.split('.')
            const filename = `${data.ID}.${splittedName[splittedName.length - 1]}`
            const oldName = `${data.ID}.${data.NOME.split('.')[1]}`
            const pathParams = isStorage 
                ? data.DIRETORIO.split('./storage/')[1]
                : data.DIRETORIO.split('./public/')[1]
            const [ routeName, order ] = pathParams.split('/')
            let href = `${this.baseUrl}/${routeName}?name=${filename}&order=${order}&oldName=${oldName}`
            await getFile(href).then(response => {
                const tagHref = URL.createObjectURL(response.data)
                const link = document.createElement("a")
                link.href = tagHref
                link.download = data.NOME
                document.body.append(link)
                link.click()
                link.remove()  
            })
        },
        async save(){
            if(this.shouldOpenChangeSectionDialog) await this.openChangeSectionDialog()

            if(this.shouldOpenSaveDialog){
                this.openSaveDialog()
            }
            else await this.upsert()
        },
        async upsert(){
            this.$route.query.id ? await this.updateCall() : await this.addNewCall()
        },
        async updateCall(noReload){
            if(this.deepEqual(this.defaultCall, this.call)) return
            else {
                this.loading = true
                this.defaultCall.USUARIO_ID = this.user.USUARIO_ID
                this.call.USUARIO_ID = this.user.USUARIO_ID
                this.call.finalDialogData = this.finalDialogData
                await updateCall({old:this.defaultCall, new:this.call, callType: this.callType, finalDialogData : this.finalDialogData, user : this.user})
                    .finally(() => {
                        if(!noReload){
                            this.getCall().then(() => {
                                this.orderFinished = this.call.situation.FINAL
                                if(this.orderFinished === 'S' && this.callCharge.ID){
                                    this.newOrderPage()
                                }
                            })
                        } else {
                            this.defaultCall.situation = this.call.situation
                        }
                        this.loading = false
                    })
            }
        },
        async getCallCharge(){
            const params = { callId: this.callId }
            const response = await getCallCharge(params)
            this.callCharge = response.data
        },
        deepEqual(pObj1, pObj2) {
            return JSON.stringify(pObj1) == JSON.stringify(pObj2)
        },
        async addNewCall(){
            const newComment = this.getNewComment()
            if(newComment.length){
                localStorage.setItem('newCommentCall', JSON.stringify(newComment))
                localStorage.setItem('editMessage', JSON.stringify(this.editMessage))
            }
            this.loading = true
            this.call.EMPRESA_ID = this.user.EMPRESA_ID
            this.call.USUARIO_ID = this.user.USUARIO_ID
            await addCall(this.call)
                .then(function(response){
                    if(response.data.callId){
                        this.$router.push({
                            path: '/atendimento',
                            query: {
                                id: response.data.callId,
                                callType: this.defaultType
                            }
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }.bind(this))
                .finally(this.loading = false)
        },
        showMessageViewIcon(item){
            var show = false
            for(var i = 0; i < item.views.length; i++) 
                if(item.views[i].VISUALIZADO == 'S' && item.views[i].USUARIO_ID != item.USUARIO_ID && item.views[i].USUARIO_ID != this.user.USUARIO_ID && !this.user.CLIENTE_ID) show = true
            return show
        },
        async getPrioritiesList(){
            await getPriorities().then(response => {
                this.callPriorities = response.data
            })
        }
        ,
        validateForm() {
            if(!this.editedItem.NOME || !this.editedItem.NOME.length)  return true
            if(!this.editedItem.EMAIL || !this.editedItem.EMAIL.length)  return true
            return false
        },
        closeDialog(){
            this.editedItem = {type:'P'}
            this.addUserDialog = false
            this.setCallResponsibles()
        },
        removeItemFromArray(array, item) {
            array = array.filter(function(i) {
                return i != item
            })
        },
        getAllCallsToLink() {
            this.loadingCallsLink = true
            getAllCallsByCompanyIdAndUserId({companyId:this.user.EMPRESA_ID, userId:this.user.USUARIO_ID})
                .then(function(response){
                    var self = this
                    this.callsToLink = response.data.filter(function(item){
                        return item.ID != self.call.ID
                    }).map(item => ({
                        ID: item.ID,
                        ASSUNTO: item.ASSUNTO,
                        REMOVE: item.REMOVE
                    }))
                    this.itemsCallToLinkFiltered = this.callsToLink
                }.bind(this))
                .finally(function(){
                    this.loadingCallsLink = false
                }.bind(this))
        },
        cancelChangeLinks(){
            this.callsLinkDialog = false
            this.linksToApply = []
        },
        applyChangeLinks(){
            for(const lta of this.linksToApply){
                const value = this.call.relatedCalls.filter(rc => rc.ID === lta.ID)
                if(value.length) value[0].REMOVE = false
                else this.call.relatedCalls.push(lta)
            }
            this.linksToApply = []
            this.callsLinkDialog = false
        },
        cancelChangeOrderLinks(){
            this.ordersLinkDialog = false
        },
        applyChangeOrderLinks(){
            this.call.PEDIDO = this.orderLinksToApply.ID 
            this.ordersLinkDialog = false
        },
        print() {
            reportCall(Object.assign(this.call, {messages:this.filteredMessages, tab: this.tab}))
        },
        setCallResponsibles(){
            if(!this.call.callResponsibles) return
            this.callResponsibles = this.call.callResponsibles.filter(function(item){
                return item.USUARIO_ID || item.new
            })
        },
        clearRequesters() {
            while(this.call.callRequesters.length) this.call.callRequesters.pop()
            while(this.clients.length) this.clients.pop()
        },
        async getResponsiblesList(){
            this.loading=true
            await loadAllResponsible({companyId : this.user.EMPRESA_ID}).then( response  => {
                this.responsibles = response.data
            })
        },
        disableSave(){
            let disable = false
            if(!this.call.client || !this.call.client.NOME) disable = true
            if(!this.call.ASSUNTO) disable = true
            if(!this.call.callRequesters.length) disable = true
            if(!this.call.DATA_INICIO) disable = true
            if(!(this.call.product_module && this.call.product_module.DESCRICAO)) disable = true
            if(this.orderFinished == 'S') disable = true
            return disable
        },
        async loadAllOrders(){
            this.loadingOrders = true
            await getAllOrders()
                .then(function(response){
                    this.orders = response.data
                }.bind(this))
                .finally(function(){
                    this.loadingOrders = false
                }.bind(this))
        },
        async getRequesters(){
            await loadAllRequesters({companyId : this.user.EMPRESA_ID, clientId : this.user.CLIENTE_ID}).then(response => {
                this.requesters = response.data
            })
        },
        // getActionUserOptions(){
        //     return [].concat(this.call.callResponsibles || [], this.call.callRequesters || [])
        // },
        closeSaveDialog(){
            this.call.situation = this.defaultCall.situation 
            this.saveDialog = false
        },
        openSaveDialog(){
            this.saveDialog = true
        },
        openChangeSectionDialog(){
            this.changeSectionDialog = true
            return new Promise((resolve, reject) => {
                this.changeSectionDialogReject = reject
                this.changeSectionDialogResolve = resolve
            })
        },
        closeChangeSectionDialog(){
            this.changeSectionDialog = false
        },
        async successSaveDialog(){
            Object.assign(this.call, {technicalDetail: this.technicalDetail})
            const noReaload = !!this.succcessSaveDialogCb
            await this.updateCall(noReaload)
            if(this.succcessSaveDialogCb){
                await this.succcessSaveDialogCb(this.succcessSaveDialogParams)
                this.succcessSaveDialogCb = null
                this.succcessSaveDialogParams = null
            }
 
            this.closeSaveDialog()
        },

        setAcaoComList(){
            this.acao_com_list = [...this.call.callResponsibles, ...this.call.callInternalResponsibles]
            for(let i = 0; i < this.call.callRequesters.length; i++){
                this.acao_com_list.push(this.call.callRequesters[i])
            }
        },
        
        setCallUserOwner(){{
            const user_owner = {
                id: this.call.ABERTURA_USUARIO_ID,
                name: this.call.ABERTURA_USUARIO_DESCRICAO,
                image: this.call.ABERTURA_USUARIO_IMAGEM_PERFIL
            }
            this.call.callUserOwner = user_owner
            this.user_owner_list = [user_owner]
        }},

        defineType(){
            switch (this.callType) {
                case this.callTypes.operator:
                    this.isOperator = true
                    break;
                case this.callTypes.customer:
                    this.isCustomer = true
                    break;
            }
            
        },
        closeControlProductivityModal(){
            this.controlProductivityDialog = false
        },
        stopPreviousAndStartWorkingInThisCall(){
            this.closeControlProductivityModal()
            this.insertUserAccess(this.accessType.out, this.lastCallIdAccessed).then(() => {
                this.insertUserAccess(this.accessType.in, this.callId)
            })
        },
        stopWorkingInThisCall(){
            this.insertUserAccess(this.accessType.out, this.callId)
        },
        startWorkingInThisCall(){
            this.insertUserAccess(this.accessType.in, this.callId)
        },
        closeInactiveModal(){
            this.inactivityDialog = false
        },
        setUserActionListener(){
            let self = this
            const inactivityTime = this.stillWorkingTime
            let inactivityTimer;

            function resetTimer() {
                clearTimeout(inactivityTimer);
                inactivityTimer = setTimeout(showMessage, inactivityTime);
            }

            function showMessage() {
                getLastUserAccesInCall({userId: self.user.USUARIO_ID}).then((response) => {
                    const lastUserAccess = response.data
                    if(lastUserAccess.TIPO_ACESSO === self.accessType.in){
                        self.stopWorkingInThisCall()
                        self.inactivityDialog = true
                    }
                })
            }

            // eventos que "contam" como atividade
            ["click", "mousemove", "keydown", "scroll", "touchstart"].forEach(event => {
                if(!self.inactivityDialog) window.addEventListener(event, resetTimer);
            });

            // inicia na primeira vez
            resetTimer();
        },
        insertUserAccess(accessType, callId){
            const params = {
                userId: this.user.USUARIO_ID,
                callId: callId,
                accessType: accessType,
                userType: this.getUserType()
            }
            return insertUserAccessInCall(params)
        },
        controlProductivity(){
            getLastUserAccesInCall({userId: this.user.USUARIO_ID}).then((response) => {
                const lastUserAccess = response.data
                this.lastCallIdAccessed = lastUserAccess.ATENDIMENTO_ID

                const isSameCall = this.lastCallIdAccessed == this.callId
                const hasNoAccessYet = !Object.keys(lastUserAccess).length
                const isStartWorking = hasNoAccessYet || lastUserAccess.TIPO_ACESSO === this.accessType.out
                const isOpenDialog = lastUserAccess.TIPO_ACESSO === this.accessType.in && !isSameCall

                if(isStartWorking){
                    this.insertUserAccess(this.accessType.in, this.callId)
                } else if(isOpenDialog){
                    this.controlProductivityDialog = true
                }
            })
        },
        createTabEvent(){
            document.addEventListener("visibilitychange", this.tabEventFunction)
        },
        destroyTabEvent(){
            document.removeEventListener("visibilitychange", this.tabEventFunction)
        },
        tabEventFunction(){
            if (document.visibilityState === "visible" && !this.inactivityDialog) {
                this.controlProductivity()
            }
        },
        getUserType(){
            return this.user.CLIENTE_ID ? 'customer' : 'operator'
        },
        goToCallType(){
            const callTypeChosen = Object.keys(this.callTypes)
                .filter(key => this.callTypes[key] != this.callType)
                .map(key => this.callTypes[key])[0]
            if(!this.isCustomerUser){
                this.$router.push({
                    path: '/atendimento',
                    query: {
                        id: this.callId,
                        callType: callTypeChosen
                    }
                }).then(() => {
                    window.location.reload();
                });
            } 
        },
        sortMessages(a, b){
            const aDate = new Date(a.DATA_HORA_DATE)
            const bDate = new Date(b.DATA_HORA_DATE)
            if(this.messageDescendingSort) return bDate - aDate
            else return aDate - bDate
        },
        changeSort(value){
            this.messageDescendingSort = value
            localStorage.setItem('messageDescendingSort', this.messageDescendingSort)
        },
        setMessageDescendingSort(){
            const value = localStorage.getItem('messageDescendingSort')
            if(value) this.messageDescendingSort = JSON.parse(value)
        },
        isFirstGroupHistoricMessage(i, item){
            return (!this.filteredMessages[i - 1] || this.filteredMessages[i - 1] && this.filteredMessages[i - 1].groupName != item.groupName)
        },
        verifySituation(){
            if(!this.isSituationInDeliveryProgress && !this.isFinalSituation) this.call.CLIENTE_SATISFEITO = 'N'
        },
        changeMainTabTitle(callId){
            const el = document.getElementById('mainTabTitle')
            el.textContent = `Kunden crm${callId ? ' - ' + callId : ''}`
        },
        async loadSections(){
            return loadAllSections()
                .then((response) => {
                    this.sections = response.data
                    if(!this.call.section.ID && !this.callId) this.call.section = this.sections.find((section) => section.PADRAO === 'S') || {}
                })
        },
        async getClients(){
            return getClientsByCompanyIdAndName().then(response => {
                this.clients = response.data
            })
        }
    },
    computed:{
        ...interceptor.mapGetters(['error']),
        ...user.mapGetters(['user', 'stillWorkingTime']),
        filteredMessages(){
            return this.actualGroupMessages.filter(m => {
                return !(m.LOG_SISTEMA == 'S' && m.DETALHAMENTO_TECNICO == 'S' && this.user.CLIENTE_ID)
            }).sort(this.sortMessages)
        },
        callResponsiblesComputed(){
            return this.call.callResponsibles
        },
        paginationMessages(){
            let auxMessages = []
            for(const message of this.filteredMessages){
                if(!auxMessages[0]) auxMessages[0] = []
                if(auxMessages[auxMessages.length - 1].length >= 100) auxMessages[auxMessages.length] = []
                auxMessages[auxMessages.length - 1].push(message)
            }

            return auxMessages
        },
        relatedCalls(){
            return this.call.relatedCalls.filter(rc => !rc.REMOVE)
        },
        callUsers(){
            return this.getUsersToNotify()
        },
        isCustomerUser(){
            return !!this.user.CLIENTE_ID
        },
        isAdmin(){
            return this.user.ADM === 'S'
        },
        allMessages(){
            let groupMessages = []
            for(const callGroup of this.call.callGroups){
                for(const message of callGroup.messages){
                    groupMessages.push(Object.assign(message, {
                        groupName: callGroup.DESCRICAO,
                        color: callGroup.COR
                    }))
                }
            }
            const defaultGroupName = translate('Geral Operadores', 'Atendimento')
            const defaultGroup = this.getGeneralCallGroup(this.messages)
            for(const message of defaultGroup.messages){
                groupMessages.push(Object.assign(message, {
                    groupName: defaultGroupName,
                    color: defaultGroup.COR,
                }))
            }

            const customerSupportGroupName = translate('Cliente/Suporte', 'Atendimento')
            const customerSupportGroup = this.getGeneralCallGroup(this.customerMessages)
            for(const message of customerSupportGroup.messages){
                groupMessages.push(Object.assign(message, {
                    groupName: customerSupportGroupName,
                    color: customerSupportGroup.COR,
                }))
            }
            
            return groupMessages.sort(this.sortMessages)
        },
        isHistoricTab(){
            const callGroup = this.call.callGroups[this.tab]
            return callGroup && callGroup.ID_GRUPO === this.getAllMessagesCallGroup().ID_GRUPO
        },
        filteredCallGroups(){
            if(this.call && this.call.callGroups){
                const historicCallGroup = this.getAllMessagesCallGroup()
                return this.call.callGroups.filter(cg => {
                    return cg.ID_GRUPO != historicCallGroup.ID_GRUPO 
                        || ( 
                            cg.ID_GRUPO === historicCallGroup.ID_GRUPO
                            && this.isAdmin
                            && this.isOperator
                        )  
                })
            }
            else return []
        },
        isCompletedModalSaveButtonDisabled(){
            return !this.finalDialogData.cep
                || !this.finalDialogData.suggestedProduct
        },
        isSituationInDeliveryProgress(){
            return this.call.situation.EM_PROCESSO_ENTREGA === 'S'
        },
        isFinalSituation(){
            return this.call.situation.FINAL === 'S'
        },
        shouldOpenSaveDialog(){
            const situation = this.situations.filter(s => s.ID === this.call.situation.ID)[0]
            return situation && situation.FINAL === 'S' && this.isFirstMessageFromACustomer && !this.call.technicalDetail
        },
        shouldOpenChangeSectionDialog(){
            return this.defaultCall.section && this.call.section && this.defaultCall.section.ID != this.call.section.ID
        },
        disableTechnicalDetailButton(){
            const situation = this.situations.filter(s => s.ID === this.call.situation.ID)[0]
            return situation && !(situation.FINAL === 'S') || !!this.call.technicalDetail
        }
    },
    created(){
        this.callId = this.$route.query.id
        this.callType = this.$route.query.callType
        this.isCreating = !this.$route.query.id
        this.defaultType = this.callTypes.customer
        this.defineType()
        this.onResize()
    },
    beforeDestroy(){
        if(this.callId){
            disconnectSocket()
        } 
        this.changeMainTabTitle()
        this.destroyTabEvent()
    },
    async mounted() {
        this.loading = true
        this.setMessageDescendingSort()
        this.onResize()
        
        const promises = [
            'getSituations', 'getComplexities', 'loadSections', 
            'getResponsiblesList', 'getRequesters', 'getAllProdModules',
            'getPrioritiesList', 'getCepList', 'getClients', 
        ].map(f => this[f]())

        if(this.callId){
            await Promise.all([this.getCall(), this.getCallCharge()])

            this.controlProductivity()
            this.createTabEvent()
            this.changeMainTabTitle(this.callId)

            connectSocket(this.user.USUARIO_ID, this.callId, this.getUserType())
        } 
        else {
            if(this.user.CLIENTE_ID) {
                getClientById(this.user.CLIENTE_ID).then(function(response){
                    this.call.client = response.data
                }.bind(this))
            }
            this.call.callRequesters = [{USUARIO_ID:this.user.USUARIO_ID, NOME:this.user.NOME, IMAGEM_PERFIL:this.user.IMAGEM_PERFIL, EMAIL: this.user.EMAIL}]
            this.call.DATA_INICIO = moment(new Date()).format('DD/MM/YYYY'),
            this.call.DATA_LIMITE = moment(new Date()).format('DD/MM/YYYY'),
            this.call.callGroups = [this.getGeneralCallGroup()]
        }
        // this.setCallResponsibles()
        var editor = document.getElementById('editor')
        if(editor) editor.firstElementChild.style.minHeight = '100px'

        Promise.all(promises).then(() => {
            this.putSituation()
            this.loading = false
        })
        
        this.setAcaoComList()
        this.setCallUserOwner()
        this.setUserActionListener()
        this.setNewComment(localStorage.getItem('newCommentCall') ? JSON.parse(localStorage.getItem('newCommentCall')) : '')
        this.editMessage = localStorage.getItem('editMessage') ? JSON.parse(localStorage.getItem('editMessage')) : this.editMessage
        localStorage.setItem('newCommentCall', '')
        localStorage.setItem('editMessage', '')
    }

}
</script>
<style scoped>
/*Essa classe é uma cópia das propriedades da classe .bodyPage, foi feito assim para aplicar essa alteração dentro do componente dialog do vuetify*/
::v-deep .imageFullVisibility{ 
    max-width: none !important;
    width: 100%;
    overflow-x: auto;
    padding: 1% 0px 2% 70px;
    text-align: left;
    position: fixed;
    height: 100%;
}

.spanComment >>> * {
    font-size: 18px !important;
    color: rgb(83, 83, 83);
}
.wraptext {
   word-wrap: break-word;
   white-space: normal;
}
.pageWrap{
    display:flex;
    flex-wrap:no-wrap;
    flex-direction: row;
}
.chatPage{
    height: 100%;
    /* width: 100%; */
    width: 65%;
    padding-right: 30px;
    padding-bottom: 0;
}


.bodyPage{
    max-width: none !important;
    width: 100%;
    overflow-x: auto;
    padding: 1% 0px 2% 70px;
    text-align: left;
    position: fixed;
    height: 100%;
}
.btn1{
    text-transform: none !important;
}
.text-left{
    text-align: left;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.leftMenu{
    height: 100%;
    /* width: 100%; */
    padding: 10px;
}
.leftMenuCardBody{
    overflow-x: auto;
    max-height: 78%;
    min-height: 78%;
}
.leftMenuCardBody::-webkit-scrollbar {
    width: 8px;
}

.leftMenuCardBody::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.leftMenuCardBody::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.bolder{
    font-weight: bolder !important;
}
.bolder >>> *{
    font-weight: bolder !important;
}

.chatPage > body{
    padding-right: 12px;
    height: 95%;
    overflow-y: auto;
}
.chatPage > body::-webkit-scrollbar {
    width: 8px;
}
.chatPage > body::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}
.chatPage > body::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.chatHeader{
    display: contents;
    width: 96%;
    height: 3em;
    position: relative;
    left: 2em;
    font-size: 20px;
    font-weight: bolder;
}
.chatHeader > button{
    position: absolute;
    right: 0px;
    bottom: 0px;
}
.noPaddingCol{
    padding: 0px 12px;
}
.row{
    margin:0;
}
.fontSize >>> *{
    font-size: 12px !important;
}
.chipChat{
    margin-left: 1em;
}
.spanComment{
    content: "\A";
    white-space: break-spaces;
    min-height: auto;
}

.spanComment > *{
    margin-bottom: 0 !important;
}
.cardCommentText{
    overflow-y: auto;
}
.cardCommentText::-webkit-scrollbar {
    height: 8px;
}

.cardCommentText::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.cardCommentText::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.topMenu{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #ececec;
    top: 0;
    z-index: 5;
    left: 0;
    display: flex;
    justify-content: center;
    /* border-radius: 0px 0px 50px 50px; */
    max-height: 30px;
    transition: max-height 0.25s ease-out;
}
.topMenu.active{
    max-height: 95.6%;
    transition: max-height 0.25s ease-in; 
    /* border-radius: 0px 0px 20px 20px; */
}
.topMenuCard{
    width: 100%;
    height: 100%;
    background: #ececec;
    top: 0;
    z-index: 5;
    max-height: 0px;
    transition: max-height 0.25s ease-out;
    visibility: hidden;
    box-shadow: none !important;
}
.topMenuCard.active{
    max-height: 92%;
    transition: max-height 0.25s ease-in; 
    visibility: visible;
}
.downIcon{
    position: absolute;
    transform: rotate(0deg);
    transition: transform 0.25s linear;
    bottom: -4px;
    z-index: 1001;
}
.downIcon.active{
    transform: rotate(180deg);
    transition: transform 0.25s linear;
}
.topDrawer{
    position: absolute;
    width: 100%;
    background: #ececec;
    top: 0;
    z-index: 4;
    left: 0;
}
.topMenu{
    visibility: hidden;
}
.textRight{
    text-align: end;
}
.kndChip{
    padding: 0px 0px 0px 8px; 
    margin: 0;
    height: 30px; 
    margin: 0px 1px 3px 1px !important;
}
.cardActions{
    height: 60px;
    min-height: 60px;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 100%;
}
.attachments{
    width: 88%;
    max-width: 88%;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    height: 3em;
    align-items: center;
}
.attachments::-webkit-scrollbar {
    height: 8px;
}

.attachments::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.attachments::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.attachments > div:hover{
    cursor: pointer !important;
}
.cardChat{
    background: #ececec;
}
.cardChat::before{
    border-right-color: #ececec !important;
}
.cardChat::after{
    border-right-color: #ececec !important;
}
.cardAvatarHistoric >>> .v-timeline-item__divider > .v-timeline-item__dot {
    background-color: var(--cardAvatarHistoric-color) !important;
    margin: var(--cardAvatarHistoric-margin) !important;
}
.bodyCallLink{
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.bodyCallLink::-webkit-scrollbar {
    width: 8px;
}

.bodyCallLink::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.bodyCallLink::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.assuntoColumn{
    max-width: 140px;
}
.inlineTable{
    display: inline-table !important;
}
.red-x-icon >>> .mdi-close-circle{
    color: red;
}
.toggleButtonDiv{
    margin-top:15px;
}
.cursor-auto {
    cursor: auto;
}
.editor >>> .ql-container > .ql-editor * {
    font-size: 18px;
}
.hoverIcon:hover {
    color: var(--v-info-darken1);
}
@media only screen and (max-width: 420px){
    .leftMenu{
        display: none;
    }
    .bodyPage{
        padding: 6% 0px 11% 0px;
    }
    .topMenu{
        visibility: visible;
    }
    .headerCallInfo{
        display: inline-table !important;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 56%;
        min-height: 56%;
    }
}
@media only screen and (min-width: 421px) and (max-width: 814px){
    .leftMenu{
        display: none;
    }
    .bodyPage{
        padding: 0;
    }
    .bodyPage{
        padding: 0% 0px 6% 40px;
    }
    .topMenu{
        visibility: visible;
        padding-left: 70px;
    }
    .topMenuCard{
        max-height: 60% !important;
    }
    .headerCallInfo{
        display: inline-table !important;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 70%;
        min-height: 70%;
    }
}
@media only screen and (min-width: 815px) and (max-width: 1399px){
    .formCard{
        margin-right:0;
        transition:ease .5s;
        width: 20%;
   }
    .headerCallInfo{
        display: inline-table !important;
        padding: 10px 0;
        margin: 10px 0 0 0;
    }
    .headerCallInfo > .actions{
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        width:100%;
        /* margin: 10px 0 0 0; */
    }
    .headerCallInfo > .actions > button{
        margin: 2px;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 70%;
        min-height: 70%;
    }
}
@media only screen and (min-width: 1400px) and (max-width: 2000px){
    .formCard{
        margin-right:0;
        transition:ease .5s;
        width: 29%;
    }
    .headerCallInfo{
        display: inline-table !important;
        padding: 15px;
        margin: 10px 0 0 0;
    }
    .headerCallInfo > .actions{
        padding: 5px;
        margin: 10px 0 0 0;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 70%;
        min-height: 70%;
    }
}
.drawer{
    padding:0;
    margin-right:12px;
    width:0;
    transition:ease .5s;
}
.vue-input-label {
    color: rgba(0, 0, 0, .6); 
    height: 20px; 
    line-height: 20px; 
    letter-spacing: normal; 
    font-size: 16px;
    cursor: pointer;
}
.color-btn {
    cursor: pointer;
    border-radius: 50%;
    width: 3em;
    height: 3em;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);
}
.color-btn-col:hover {
    opacity: .7;
    cursor: pointer;
}
#callGroupColorMenu > *[disabled] {
    opacity: .7;
    cursor: auto;
}
</style>